import { observable, action, computed, runInAction, toJS as toJS$1, extendObservable } from 'mobx';
import { flatten, map, head, path, curry, objOf, uniq as uniq$1, mergeDeepRight, merge, groupBy, pathEq, compose, difference, __, filter, propEq, concat, pickAll, prop, tail, find as find$1, reject, pipe, intersection, isEmpty, not, uncurryN, reduce, all, equals, anyPass, isNil, is } from 'ramda';
import Qty from 'js-quantities';
import moment from 'moment';
import sanitize from 'sanitize-filename';
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }
  return object;
}
function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);
      if (desc.get) {
        return desc.get.call(receiver);
      }
      return desc.value;
    };
  }
  return _get(target, property, receiver || target);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _initializerDefineProperty(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object.keys(descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;
  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }
  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);
  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }
  if (desc.initializer === void 0) {
    Object.defineProperty(target, property, desc);
    desc = null;
  }
  return desc;
}
var IF2JsModelError = /*#__PURE__*/function (_Error) {
  _inherits(IF2JsModelError, _Error);
  var _super = _createSuper(IF2JsModelError);
  function IF2JsModelError(message) {
    var _this;
    _classCallCheck(this, IF2JsModelError);
    _this = _super.call(this, message);
    _this.name = _this.constructor.name;
    return _this;
  }
  return IF2JsModelError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
var GeoJsonError = /*#__PURE__*/function (_IF2JsModelError) {
  _inherits(GeoJsonError, _IF2JsModelError);
  var _super = _createSuper(GeoJsonError);
  function GeoJsonError() {
    _classCallCheck(this, GeoJsonError);
    return _super.apply(this, arguments);
  }
  return GeoJsonError;
}(IF2JsModelError);
var InvalidFeatureError = /*#__PURE__*/function (_GeoJsonError) {
  _inherits(InvalidFeatureError, _GeoJsonError);
  var _super = _createSuper(InvalidFeatureError);
  function InvalidFeatureError() {
    _classCallCheck(this, InvalidFeatureError);
    return _super.call(this, 'Invalid GeoJSON feature');
  }
  return InvalidFeatureError;
}(GeoJsonError);
var InvalidGeoJsonError = /*#__PURE__*/function (_GeoJsonError) {
  _inherits(InvalidGeoJsonError, _GeoJsonError);
  var _super = _createSuper(InvalidGeoJsonError);
  function InvalidGeoJsonError() {
    _classCallCheck(this, InvalidGeoJsonError);
    return _super.call(this, 'Invalid GeoJSON');
  }
  return InvalidGeoJsonError;
}(GeoJsonError);
var UnsupportedGeometryTypeError = /*#__PURE__*/function (_GeoJsonError) {
  _inherits(UnsupportedGeometryTypeError, _GeoJsonError);
  var _super = _createSuper(UnsupportedGeometryTypeError);
  function UnsupportedGeometryTypeError(type) {
    var _this;
    _classCallCheck(this, UnsupportedGeometryTypeError);
    _this = _super.call(this, "Unsupported GeoJSON geometry type: '".concat(type, "'"));
    _this.type = type;
    return _this;
  }
  return UnsupportedGeometryTypeError;
}(GeoJsonError);
var idAttributeMixin = function idAttributeMixin(Base) {
  return /*#__PURE__*/function (_Base) {
    _inherits(_class, _Base);
    var _super = _createSuper(_class);
    function _class() {
      _classCallCheck(this, _class);
      return _super.apply(this, arguments);
    }
    _createClass(_class, null, [{
      key: "getAttributeDefinition",
      value: function getAttributeDefinition() {
        return _objectSpread2(_objectSpread2({}, _get(_getPrototypeOf(_class), "getAttributeDefinition", this).call(this)), {}, {
          id: {
            name: 'ID',
            key: 'id',
            type: 'string'
          }
        });
      }
    }]);
    return _class;
  }(Base);
};
var nameAttributeMixin = function nameAttributeMixin(Base) {
  return /*#__PURE__*/function (_Base) {
    _inherits(_class, _Base);
    var _super = _createSuper(_class);
    function _class() {
      _classCallCheck(this, _class);
      return _super.apply(this, arguments);
    }
    _createClass(_class, null, [{
      key: "getAttributeDefinition",
      value: function getAttributeDefinition() {
        return _objectSpread2(_objectSpread2({}, _get(_getPrototypeOf(_class), "getAttributeDefinition", this).call(this)), {}, {
          name: {
            name: 'Name',
            key: 'name',
            type: 'string'
          }
        });
      }
    }]);
    return _class;
  }(Base);
};
var serialAttributeMixin = function serialAttributeMixin(Base) {
  return /*#__PURE__*/function (_Base) {
    _inherits(_class, _Base);
    var _super = _createSuper(_class);
    function _class() {
      _classCallCheck(this, _class);
      return _super.apply(this, arguments);
    }
    _createClass(_class, null, [{
      key: "getAttributeDefinition",
      value: function getAttributeDefinition() {
        return _objectSpread2(_objectSpread2({}, _get(_getPrototypeOf(_class), "getAttributeDefinition", this).call(this)), {}, {
          serial: {
            name: 'Serial',
            key: 'serial',
            type: 'number'
          }
        });
      }
    }]);
    return _class;
  }(Base);
};
var typeAttributeMixin = function typeAttributeMixin(Base) {
  return /*#__PURE__*/function (_Base) {
    _inherits(_class, _Base);
    var _super = _createSuper(_class);
    function _class() {
      _classCallCheck(this, _class);
      return _super.apply(this, arguments);
    }
    _createClass(_class, null, [{
      key: "getAttributeDefinition",
      value: function getAttributeDefinition() {
        return _objectSpread2(_objectSpread2({}, _get(_getPrototypeOf(_class), "getAttributeDefinition", this).call(this)), {}, {
          type: {
            name: 'Type',
            key: 'type',
            type: 'string'
          }
        });
      }
    }]);
    return _class;
  }(Base);
};
var checkableMixin = function checkableMixin(Base) {
  var _class, _descriptor;
  return _class = /*#__PURE__*/function (_Base) {
    _inherits(_class, _Base);
    var _super = _createSuper(_class);
    function _class() {
      var _this;
      _classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _initializerDefineProperty(_assertThisInitialized(_this), "isChecked", _descriptor, _assertThisInitialized(_this));
      return _this;
    }
    _createClass(_class, [{
      key: "check",
      value: function check() {
        this.isChecked = true;
      }
    }, {
      key: "unCheck",
      value: function unCheck() {
        this.isChecked = false;
      }
    }, {
      key: "toggleChecked",
      value: function toggleChecked() {
        this.isChecked = !this.isChecked;
      }
    }]);
    return _class;
  }(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isChecked", [observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "check", [action], Object.getOwnPropertyDescriptor(_class.prototype, "check"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unCheck", [action], Object.getOwnPropertyDescriptor(_class.prototype, "unCheck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleChecked", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleChecked"), _class.prototype)), _class;
};
var checkableCollectionMixin = function checkableCollectionMixin(Base) {
  var _class, _descriptor;
  return _class = /*#__PURE__*/function (_Base) {
    _inherits(_class, _Base);
    var _super = _createSuper(_class);
    function _class() {
      var _this;
      _classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _initializerDefineProperty(_assertThisInitialized(_this), "_checked", _descriptor, _assertThisInitialized(_this));
      return _this;
    }
    _createClass(_class, [{
      key: "checked",
      get: function get() {
        return _toConsumableArray(this._checked.keys());
      }
    }, {
      key: "isChecked",
      value: function isChecked(id) {
        return this._checked.has(id);
      }
    }, {
      key: "toggleChecked",
      value: function toggleChecked(id) {
        if (!this.isChecked(id)) {
          this.check(id);
          return;
        }
        this.unCheck(id);
      }
    }, {
      key: "checkMany",
      value: function checkMany(ids) {
        var _this2 = this;
        ids.forEach(function (id) {
          _this2.check(id);
        });
      }
    }, {
      key: "unCheckMany",
      value: function unCheckMany(ids) {
        var _this3 = this;
        ids.forEach(function (id) {
          _this3.unCheck(id);
        });
      }
    }, {
      key: "check",
      value: function check(id) {
        this._checked.set(id, true);
      }
    }, {
      key: "unCheck",
      value: function unCheck(id) {
        this._checked["delete"](id);
      }
    }, {
      key: "setCheck",
      value: function setCheck(id, isChecked) {
        if (isChecked) {
          this.check(id);
          return;
        }
        this.unCheck(id);
      }
    }, {
      key: "unCheckAll",
      value: function unCheckAll() {
        this._checked.clear();
      }
    }]);
    return _class;
  }(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_checked", [observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return new Map();
    }
  }), _applyDecoratedDescriptor(_class.prototype, "checked", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "checked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleChecked", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleChecked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkMany", [action], Object.getOwnPropertyDescriptor(_class.prototype, "checkMany"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unCheckMany", [action], Object.getOwnPropertyDescriptor(_class.prototype, "unCheckMany"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "check", [action], Object.getOwnPropertyDescriptor(_class.prototype, "check"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unCheck", [action], Object.getOwnPropertyDescriptor(_class.prototype, "unCheck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCheck", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setCheck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unCheckAll", [action], Object.getOwnPropertyDescriptor(_class.prototype, "unCheckAll"), _class.prototype)), _class;
};
var editableMixin = function editableMixin(Base) {
  var _class, _descriptor;
  return _class = /*#__PURE__*/function (_Base) {
    _inherits(_class, _Base);
    var _super = _createSuper(_class);
    function _class() {
      var _this;
      _classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _initializerDefineProperty(_assertThisInitialized(_this), "isBeingEdited", _descriptor, _assertThisInitialized(_this));
      return _this;
    }
    _createClass(_class, [{
      key: "openEdit",
      value: function openEdit() {
        this.isBeingEdited = true;
      }
    }, {
      key: "closeEdit",
      value: function closeEdit() {
        this.isBeingEdited = false;
      }
    }, {
      key: "toggleEdit",
      value: function toggleEdit() {
        this.isBeingEdited = !this.isBeingEdited;
      }
    }]);
    return _class;
  }(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isBeingEdited", [observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "openEdit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openEdit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeEdit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeEdit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleEdit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleEdit"), _class.prototype)), _class;
};
var expandableCollectionMixin = function expandableCollectionMixin(Base) {
  var _class, _descriptor;
  return _class = /*#__PURE__*/function (_Base) {
    _inherits(_class, _Base);
    var _super = _createSuper(_class);
    function _class() {
      var _this;
      _classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _initializerDefineProperty(_assertThisInitialized(_this), "_expanded", _descriptor, _assertThisInitialized(_this));
      return _this;
    }
    _createClass(_class, [{
      key: "expanded",
      get: function get() {
        return _toConsumableArray(this._expanded.keys());
      }
    }, {
      key: "toggleExpanded",
      value: function toggleExpanded(id) {
        if (this.isCollapsed(id)) {
          this.expand(id);
          return;
        }
        this.collapse(id);
      }
    }, {
      key: "expandMany",
      value: function expandMany(ids) {
        var _this2 = this;
        ids.forEach(function (id) {
          _this2.expand(id);
        });
      }
    }, {
      key: "collapseMany",
      value: function collapseMany(ids) {
        var _this3 = this;
        ids.forEach(function (id) {
          _this3.collapse(id);
        });
      }
    }, {
      key: "expand",
      value: function expand(id) {
        this._expanded.set(id, true);
      }
    }, {
      key: "collapse",
      value: function collapse(id) {
        this._expanded["delete"](id);
      }
    }, {
      key: "isExpanded",
      value: function isExpanded(id) {
        return this._expanded.has(id);
      }
    }, {
      key: "isCollapsed",
      value: function isCollapsed(id) {
        return !this._expanded.has(id);
      }
    }, {
      key: "setExpand",
      value: function setExpand(id, isExpanded) {
        if (isExpanded) {
          this.expand(id);
          return;
        }
        this.collapse(id);
      }
    }, {
      key: "collapseAll",
      value: function collapseAll() {
        this._expanded.clear();
      }
    }]);
    return _class;
  }(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_expanded", [observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return new Map();
    }
  }), _applyDecoratedDescriptor(_class.prototype, "expanded", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "expanded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleExpanded", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleExpanded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "expandMany", [action], Object.getOwnPropertyDescriptor(_class.prototype, "expandMany"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "collapseMany", [action], Object.getOwnPropertyDescriptor(_class.prototype, "collapseMany"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "expand", [action], Object.getOwnPropertyDescriptor(_class.prototype, "expand"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "collapse", [action], Object.getOwnPropertyDescriptor(_class.prototype, "collapse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setExpand", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setExpand"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "collapseAll", [action], Object.getOwnPropertyDescriptor(_class.prototype, "collapseAll"), _class.prototype)), _class;
};
var loggableMixin = function loggableMixin(Base) {
  var _class, _temp;
  return _temp = _class = /*#__PURE__*/function (_Base) {
    _inherits(_class, _Base);
    var _super = _createSuper(_class);
    function _class() {
      _classCallCheck(this, _class);
      return _super.apply(this, arguments);
    }
    _createClass(_class, [{
      key: "logger",
      get: function get() {
        return this.constructor.logger;
      }
    }], [{
      key: "setLogger",
      value: function setLogger(logger) {
        this.logger = logger;
      }
    }, {
      key: "resetLogger",
      value: function resetLogger() {
        this.logger = console;
      }
    }]);
    return _class;
  }(Base), _defineProperty(_class, "logger", console), _temp;
};

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }
  return getRandomValues(rnds8);
}
var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}
function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0; // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434

  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }
  return uuid;
}
function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;
    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }
    return buf;
  }
  return stringify(rnds);
}
var _class$g, _class2$c, _temp$c;
var Spec = (_class$g = (_temp$c = _class2$c = /*#__PURE__*/function () {
  function Spec(props) {
    var _this = this;
    _classCallCheck(this, Spec);
    _defineProperty(this, "accessorsForKey", function (key) {
      return _this.constructor.accessorsForAttribute(_this.findAttribute(key));
    });
    this.attributeDefinition = (props === null || props === void 0 ? void 0 : props.attributeDefinition) || {};
    this.defaultKey = (props === null || props === void 0 ? void 0 : props.defaultKey) || 'name';
  }
  _createClass(Spec, [{
    key: "findAttribute",
    value: function findAttribute(k) {
      return Array.isArray(this.attributes) && this.attributes.find(function (a) {
        return [a.key, a.jsKey].includes(k);
      }) || undefined;
    }
  }, {
    key: "accessors",
    get: function get() {
      return flatten(map(this.constructor.accessorsForAttribute, this.attributes));
    }
  }, {
    key: "attributes",
    get: function get() {
      return Object.values(this.attributeDefinition || {});
    }
  }, {
    key: "defaultAccessor",
    get: function get() {
      var accessor = head(flatten([this.accessorsForKey(this.defaultKey)]));
      if (!(accessor !== null && accessor !== void 0 && accessor.attribute)) {
        return;
      }
      if (['model', 'modelCollection'].includes(accessor.attribute.type)) {
        return this.constructor.descendantAccessor(accessor.attribute.modelClass.spec.defaultAccessor, accessor.attribute.key);
      }
      return accessor;
    }
  }]);
  return Spec;
}(), _defineProperty(_class2$c, "accessorsForAttribute", function (attribute) {
  if (!attribute) {
    return {
      path: [],
      attribute: attribute
    };
  }
  if (['model', 'modelCollection'].includes(attribute.type)) {
    return _class2$c.expandDescendantAccessors(attribute);
  }
  return {
    path: [attribute.key],
    attribute: attribute
  };
}), _defineProperty(_class2$c, "descendantAccessor", function (accessor, prefix) {
  return {
    path: [prefix].concat(accessor.path),
    attribute: accessor.attribute
  };
}), _defineProperty(_class2$c, "expandDescendantAccessors", function (attribute) {
  return [{
    path: [attribute.key],
    attribute: attribute
  }, attribute.modelClass.spec.accessors.map(function (accessor) {
    return _class2$c.descendantAccessor(accessor, attribute.key);
  })];
}), _temp$c), (_applyDecoratedDescriptor(_class$g.prototype, "accessors", [computed], Object.getOwnPropertyDescriptor(_class$g.prototype, "accessors"), _class$g.prototype), _applyDecoratedDescriptor(_class$g.prototype, "attributes", [computed], Object.getOwnPropertyDescriptor(_class$g.prototype, "attributes"), _class$g.prototype), _applyDecoratedDescriptor(_class$g.prototype, "defaultAccessor", [computed], Object.getOwnPropertyDescriptor(_class$g.prototype, "defaultAccessor"), _class$g.prototype)), _class$g);
var groupAccessorsByType = function groupAccessorsByType(accessors) {
  var ownAccessors = accessors.filter(function (accessor) {
    return accessor.path.length === 1;
  });
  return merge({
    all: accessors
  }, groupBy(function (accessor) {
    return pathEq(['attribute', 'type'], 'modelCollection', accessor) ? 'collections' : pathEq(['attribute', 'type'], 'model', accessor) ? 'models' : 'literals';
  })(ownAccessors));
}; // parent column may have been removed.  If so, we need to include its
// accessor so that we properly report on its children

var hiddenCollectionAttributes = function hiddenCollectionAttributes(accessors, accessorGroups) {
  return compose(difference(__, map(function (accessor) {
    return accessor.path[0];
  }, accessorGroups.collections || [])), map(function (accessor) {
    return accessor.path[0];
  }), filter(function (accessor) {
    return accessor.path.length > 1;
  }))(accessors);
};
var pickKeyFromAccessor = path(['attribute', 'key']);
var defaultAccessorForKey = function defaultAccessorForKey(key) {
  return compose(function (accessor) {
    return merge(accessor, {
      path: [key].concat(accessor.path)
    });
  }, function (accessor) {
    return accessor.attribute.modelClass.spec.defaultAccessor;
  }, find$1(function (accessor) {
    return accessor.attribute.key === key;
  }));
};
var filterDescendantAccessors = function filterDescendantAccessors(key) {
  return filter(function (accessor) {
    return accessor.path.length > 1 && accessor.path[0] === key;
  });
};
var childAccessorsForKey = function childAccessorsForKey(key) {
  return function (accessors) {
    return compose(uniq$1, map(function (accessor) {
      return merge(accessor, {
        path: tail(accessor.path)
      });
    }), concat([defaultAccessorForKey(key)(accessors)]), filterDescendantAccessors(key))(accessors);
  };
};
var constructReportsForKey = curry(function (reports, key) {
  return map(function (report) {
    return objOf(key, report);
  }, reports);
}); // This mixin adds a `report()` method to a model which outputs an array of
// report rows that can be used to display the data contained in the model in
// a tabular way.  The method accepts an array of "accessors", which specify
// which attributes (including nested attributes) should be included in the report.

var reportableMixin = function reportableMixin(Base) {
  return /*#__PURE__*/function (_Base) {
    _inherits(_class2, _Base);
    var _super = _createSuper(_class2);
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "isReportable", true);
      _defineProperty(_assertThisInitialized(_this), "mergeReportRows", curry(function (firstSet, secondSet) {
        return uniq$1(flatten(firstSet).length < 1 ? secondSet : firstSet.reduce(function (acc, curr) {
          return flatten(acc.length < 1 ? curr : acc.map(function (accRow) {
            return curr.length < 1 ? accRow : curr.map(function (currRow) {
              return mergeDeepRight(accRow, currRow);
            });
          }));
        }, secondSet));
      }));
      return _this;
    }
    _createClass(_class2, [{
      key: "accessorGroupsToReport",
      value: function accessorGroupsToReport(accessors) {
        var _this2 = this;
        var accessorGroups = groupAccessorsByType(accessors);
        var hiddenCollectionKeys = hiddenCollectionAttributes(accessors, accessorGroups);
        hiddenCollectionKeys.forEach(function (key) {
          var parentAccessor = _this2.rootAccessorForKey(key);
          accessorGroups.all.push(parentAccessor);
          if (propEq('type', 'modelCollection', parentAccessor.attribute)) {
            accessorGroups.collections = compose(filter(Boolean), flatten, concat(accessorGroups.collections || []))([parentAccessor]);
          }
          if (propEq('type', 'model', parentAccessor.attribute)) {
            accessorGroups.models = compose(filter(Boolean), flatten, concat(accessorGroups.models || []))([parentAccessor]);
          }
        });
        return accessorGroups;
      }
    }, {
      key: "reportLiterals",
      value: function reportLiterals(accessorGroups) {
        if (!accessorGroups) return [];
        return [pickAll(map(pickKeyFromAccessor, prop('literals', accessorGroups) || []).concat('id'), this)];
      }
    }, {
      key: "reportCollections",
      value: function reportCollections(accessorGroups) {
        var _this3 = this;
        return map(compose(function (key) {
          return constructReportsForKey(flatten(map(function (item) {
            return item.report(childAccessorsForKey(key)(accessorGroups.all));
          }, _this3[key])))(key);
        }, pickKeyFromAccessor), prop('collections', accessorGroups) || []);
      }
    }, {
      key: "reportModels",
      value: function reportModels(accessorGroups) {
        var _this4 = this;
        return compose(map(compose(function (key) {
          return constructReportsForKey(flatten(_this4[key].report(childAccessorsForKey(key)(accessorGroups.all))))(key);
        }, pickKeyFromAccessor)), reject(function (accessor) {
          return !_this4[pickKeyFromAccessor(accessor)];
        }))(prop('models', accessorGroups) || []);
      }
    }, {
      key: "rootAccessorForKey",
      value: function rootAccessorForKey(key) {
        var accessors = this.constructor.spec.accessorsForKey(key);
        return Array.isArray(accessors) ? accessors[0] : accessors;
      }
    }, {
      key: "report",
      value: function report(accessorsToReport) {
        var accessorGroups = this.accessorGroupsToReport([].concat(accessorsToReport)); // for literal attributes, add the value to the literals report row at that
        // key (e.g., [{ id: '1234', serial: 1 }])

        var literalReportRows = this.reportLiterals(accessorGroups); // for collection attributes, generate report rows for each collection
        // item and store those under the collection attribute's key:
        //    [
        //      { productApplications: { id: '234', sprayRecordId: 1 } },
        //      { productApplications: { id: '235', sprayRecordId: 1 } }
        //    ]

        var collectionReports = this.reportCollections(accessorGroups);
        var modelReports = this.reportModels(accessorGroups); // combine report rows.  Literal values need to be merged into expanded
        // rows

        return compose(map(function (r) {
          return _objectSpread2(_objectSpread2({}, r), {}, {
            _rowId: v4()
          });
        }), this.mergeReportRows(modelReports), this.mergeReportRows(collectionReports))(literalReportRows);
      }
    }], [{
      key: "spec",
      get: function get() {
        return new Spec({
          // these static variables (reportableAttributes and defaultKey) must be
          // defined on the Base class or somewhere else in the prototype chain
          attributeDefinition: this.reportableAttributes,
          defaultKey: this.defaultKey
        });
      }
    }]);
    return _class2;
  }(Base);
}; // exported for testing purposes

var selectableMixin = function selectableMixin(Base) {
  var _class, _descriptor;
  return _class = /*#__PURE__*/function (_Base) {
    _inherits(_class, _Base);
    var _super = _createSuper(_class);
    function _class() {
      var _this;
      _classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _initializerDefineProperty(_assertThisInitialized(_this), "isSelected", _descriptor, _assertThisInitialized(_this));
      return _this;
    }
    _createClass(_class, [{
      key: "select",
      value: function select() {
        this.isSelected = true;
      }
    }, {
      key: "deselect",
      value: function deselect() {
        this.isSelected = false;
      }
    }, {
      key: "toggleSelected",
      value: function toggleSelected() {
        this.isSelected = !this.isSelected;
      }
    }]);
    return _class;
  }(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isSelected", [observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "select", [action], Object.getOwnPropertyDescriptor(_class.prototype, "select"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deselect", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deselect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSelected", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSelected"), _class.prototype)), _class;
};
var timestampAttributesMixin = function timestampAttributesMixin(Base) {
  return /*#__PURE__*/function (_Base) {
    _inherits(_class, _Base);
    var _super = _createSuper(_class);
    function _class() {
      _classCallCheck(this, _class);
      return _super.apply(this, arguments);
    }
    _createClass(_class, null, [{
      key: "getAttributeDefinition",
      value: function getAttributeDefinition() {
        return _objectSpread2(_objectSpread2({}, _get(_getPrototypeOf(_class), "getAttributeDefinition", this).call(this)), {}, {
          createdAt: {
            name: 'Created At',
            key: 'createdAt',
            type: 'string'
          },
          updatedAt: {
            name: 'Updated At',
            key: 'updatedAt',
            type: 'string'
          }
        });
      }
    }]);
    return _class;
  }(Base);
};
var uniq = function uniq(a) {
  return _toConsumableArray(new Set(a));
};
var uniqBy = function uniqBy(key, a) {
  return Array.from(new Map(a.map(function (element) {
    return [element[key], element];
  })).values());
};
var includesAll = curry(function (subArray, superArray) {
  return subArray.every(function (item) {
    return superArray.includes(item);
  });
});
var includesAny = curry(function (subArray, superArray) {
  return pipe(intersection(subArray), isEmpty, not)(superArray);
});
var find = function find(collection, id, maybeOptions) {
  var options = maybeOptions || {};
  var searchKey = options.searchKey || 'id';
  return collection.find(function (item) {
    return item[searchKey] === id;
  });
};
var findMany = function findMany(collection, ids) {
  var itemMap = collection.reduce(function (acc, curr) {
    acc.set(curr.id, curr);
    return acc;
  }, new Map());
  return ids.reduce(function (all, id) {
    var item = itemMap.get(id);
    if (item) {
      all.push(item);
    }
    return all;
  }, []);
};
var push = function push(collection, modelFactory, doc, maybeOptions) {
  return runInAction(function () {
    var options = maybeOptions || {};
    var searchKey = options.searchKey || 'id';
    var hash = _objectSpread2(_objectSpread2({}, doc), {}, {
      id: doc.id || doc._id
    });
    var item = find(collection, hash[searchKey], {
      searchKey: searchKey
    });
    if (item) {
      item.update(hash);
    } else {
      item = modelFactory(hash);
      Object.keys(options.initProps || {}).forEach(function (key) {
        item[key] = options.initProps[key];
      });
      runInAction(function () {
        return collection.push(item);
      });
    }
    return item;
  });
};
var remove = function remove(collection, id, maybeOptions) {
  return runInAction(function () {
    var options = maybeOptions || {};
    var searchKey = options.searchKey || 'id';
    var idx = collection.findIndex(function (item) {
      return item[searchKey] === id;
    });
    if (idx >= 0) {
      return collection.splice(idx, 1)[0];
    }
  });
};
var AbstractBase = function AbstractBase() {
  _classCallCheck(this, AbstractBase);
};
var MixInto = curry(uncurryN(2, function (Base) {
  return function () {
    return /*#__PURE__*/function (_pipe) {
      _inherits(_class, _pipe);
      var _super = _createSuper(_class);
      function _class() {
        _classCallCheck(this, _class);
        return _super.apply(this, arguments);
      }
      return _class;
    }(pipe.apply(void 0, arguments)(Base));
  };
}));
var Mix = MixInto(AbstractBase);
var genericSort = function genericSort(a, b) {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
};
var naturalSort = function naturalSort(a, b) {
  return String(a).localeCompare(String(b), navigator.languages[0] || navigator.language, {
    numeric: true,
    ignorePunctuation: true
  });
};
var sortByName = function sortByName(a, b) {
  return a.name && b.name ? naturalSort(String(a.name).toLowerCase(), String(b.name).toLowerCase()) : 0;
};
var isString = function isString(value) {
  return typeof value === 'string' || value instanceof String;
};
var percentStringToDecimal = function percentStringToDecimal(percent) {
  if (!isString(percent)) return null;
  var scalar;
  if (percent.slice(-1) !== '%') {
    scalar = percent;
  } else {
    scalar = percent.slice(0, -1);
  }
  scalar = Number(scalar);
  if (Number.isNaN(scalar)) return null;
  return scalar / 100;
};
var bulletListString = function bulletListString(termArray) {
  return termArray.map(function (term) {
    return "\t\u2022 ".concat(term);
  }).join('\n');
};
var listString = function listString(termArray) {
  if (termArray.length < 2) {
    return termArray[0] || '';
  }
  var initialList = [].concat(termArray.slice(0, -2).join(', ') || []);
  var lastTwo = termArray.slice(-2);
  var listEnd = initialList.length ? lastTwo.join(', and ') : lastTwo.join(' and ');
  return initialList.concat(listEnd).join(', ');
};
var decimalToPercentString = function decimalToPercentString(decimal) {
  if (decimal === undefined || decimal === null || decimal === '') return null;
  var number = Number(decimal);
  if (Number.isNaN(number)) return null;
  var percent = number * 100;
  var percentString;
  if (percent >= 100) {
    percentString = percent.toFixed(0);
  } else {
    percentString = percent.toFixed(2).replace(/\.?0*$/, '');
  }
  return "".concat(percentString, "%");
};
var humanize = function humanize(s) {
  return s.replace(/([A-Z])/g, ' $1').trim().split(' ').map(function (str) {
    return "".concat(str.slice(0, 1).toUpperCase()).concat(str.slice(1));
  }).join(' ');
};

// Implementing our own toJS here also allows us to call our own model.toJS
// methods if the models happen to be nested within standard observable objects
// or arrays.  We only explicitly handle arrays and plain objects (objects with
// the Object prototype).  This should be enough in most cases and is fairly
// safe.  If we converted all objects, we run the risk of breaking expected
// behavior.  For example, we depend on objects with a d3 HSL prototype after
// having called toJS on our GeoJSON FeatureCollection models to properly
// display colors of GeoJSON features on maps.

var toJS = function toJS(val) {
  return !val ? toJS$1(val) : typeof val.slice === 'function' && Array.isArray(val.slice()) ? val.slice().map(toJS) : typeof val.toJS === 'function' ? val.toJS() : _typeof(val) === 'object' && Object.getPrototypeOf(val) === Object.prototype ? Object.keys(val).reduce(function (acc, curr) {
    acc[curr] = toJS(val[curr]);
    return acc;
  }, {}) : toJS$1(val);
};
var truncateZeros = function truncateZeros(number) {
  if (Number.isNaN(Number(number))) return;
  var value = "".concat(number).replace(/\.0*$/, '');
  var pattern = /(\d*\.\d*[1-9])0+$/;
  return value.replace(pattern, '$1');
};

// according to the static `attributeDefinition` present on the class.  This
// should be mixed in before other mixins that depend on observable behavior.
// Its constructor will add all the attributes in the attributeDefinition as
// observable properties of the class instance.

var updatableMixin = function updatableMixin(Base) {
  var _class, _init, _class2, _temp;
  return _class = (_temp = _class2 = /*#__PURE__*/function (_Base) {
    _inherits(_class, _Base);
    var _super = _createSuper(_class);
    function _class() {
      var _this;
      _classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      var attributes = _this.allAttributes.reduce(function (acc, attribute) {
        var _ref, _this$attribute$key;
        var result = acc;
        result[attribute.key] = (_ref = (_this$attribute$key = _this[attribute.key]) !== null && _this$attribute$key !== void 0 ? _this$attribute$key : attribute.defaultValue) !== null && _ref !== void 0 ? _ref : _this.constructor.defaultValueFor(attribute.type);
        return result;
      }, {});
      extendObservable(_assertThisInitialized(_this), attributes);
      return _this;
    }
    _createClass(_class, [{
      key: "allAttributes",
      get: function get() {
        return this.constructor._allAttributes;
      }
    }, {
      key: "attributeDefinition",
      get: function get() {
        return this.constructor.attributeDefinition;
      }
    }, {
      key: "_attributeMap",
      get: function get() {
        var _this2 = this;
        return this.allAttributes.reduce(function (acc, cur) {
          // include all three possibilities for the model key
          acc[cur.key] = cur;
          acc[cur.jsKey] = cur;
          acc[_this2.constructor.toSnakeCase(cur.key)] = cur;
          return acc;
        }, {});
      }
    }, {
      key: "attributes",
      get: function get() {
        var _this3 = this;
        return this.allAttributes.map(function (a) {
          return {
            key: a.key,
            value: _this3[a.key]
          };
        });
      }
    }, {
      key: "duplicate",
      value: function duplicate() {
        return new this.constructor(this.toJS());
      }
    }, {
      key: "findAttribute",
      value: function findAttribute(target) {
        return this.attributeDefinition[target] || this._attributeMap[target];
      }
    }, {
      key: "serialize",
      value: function serialize() {
        console.warn("".concat(this.constructor.name, ".serialize() is deprecated! please use toJS() instead"));
        return this.toJS();
      }
    }, {
      key: "toJS",
      value: function toJS$1() {
        var _this4 = this;
        return this.allAttributes.reduce(function (acc, attribute) {
          if (attribute.key === 'rev') return acc;
          var key = attribute.jsKey || _this4.constructor.toSnakeCase(attribute.key);
          if (attribute.type === 'string') {
            acc[key] = _this4[attribute.key] || null;
            return acc;
          }
          if (attribute.type === 'number') {
            acc[key] = _this4[attribute.key] === 0 ? 0 : _this4[attribute.key] || null;
            return acc;
          }
          if (attribute.type === 'model') {
            if (_this4[attribute.key] && typeof _this4[attribute.key].toJS === 'function') {
              acc[key] = _this4[attribute.key].toJS();
              return acc;
            }
          }
          if (attribute.type === 'modelCollection') {
            acc[key] = _this4[attribute.key].map(function (element) {
              return element && typeof element.toJS === 'function' && element.toJS();
            }).filter(Boolean);
            return acc;
          }
          if (attribute.type === 'array') {
            acc[key] = toJS(_this4[attribute.key] || []);
            return acc;
          }
          if (attribute.type === 'object') {
            acc[key] = toJS(_this4[attribute.key]);
            return acc;
          }
          acc[key] = _this4[attribute.key];
          return acc;
        }, {});
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        return this.toJS();
      }
    }, {
      key: "defaultValueOf",
      value: function defaultValueOf(attribute) {
        var _this$findAttribute;
        return (_this$findAttribute = this.findAttribute(attribute)) === null || _this$findAttribute === void 0 ? void 0 : _this$findAttribute.defaultValue;
      }
    }, {
      key: "update",
      value: function update(maybeProps) {
        var _this5 = this;
        var props = maybeProps || {};
        var simpleProps = [];
        var modelProps = [];
        var modelCollectionProps = [];
        Object.keys(props).forEach(function (key) {
          var attribute = _this5.findAttribute(key);
          if (!attribute) {
            // ignore props that are not in the definition
            return;
          }
          if (attribute.type === 'string') {
            simpleProps.push({
              key: attribute.key,
              value: props[key] || ''
            });
            return;
          }
          if (attribute.type === 'boolean') {
            simpleProps.push({
              key: attribute.key,
              value: props[key] || false
            });
            return;
          }
          if (attribute.type === 'number') {
            simpleProps.push({
              key: attribute.key,
              value: props[key] === 0 ? 0 : props[key] || ''
            });
            return;
          }
          if (attribute.type === 'array') {
            simpleProps.push({
              key: attribute.key,
              value: props[key] || []
            });
            return;
          }
          if (attribute.type === 'object') {
            simpleProps.push({
              key: attribute.key,
              value: props[key]
            });
            return;
          }
          if (attribute.type === 'model') {
            modelProps.push({
              key: attribute.key,
              value: props[key],
              modelClass: attribute.modelClass
            });
            return;
          }
          if (attribute.type === 'modelCollection') {
            modelCollectionProps.push({
              key: attribute.key,
              value: props[key],
              modelClass: attribute.modelClass,
              searchKey: attribute.searchKey || 'id'
            });
          }
        });
        this.updateSimpleAttributes(simpleProps);
        modelProps.forEach(function (prop) {
          return _this5.updateModelAttribute(prop);
        });
        this.updateModelCollectionAttributes(modelCollectionProps);
        return this;
      }
    }, {
      key: "updateSimpleAttributes",
      value: function updateSimpleAttributes(propList) {
        var _this6 = this;
        propList.forEach(function (prop) {
          _this6[prop.key] = prop.value;
        });
      }
    }, {
      key: "updateModelAttribute",
      value: function updateModelAttribute(prop) {
        if (prop.value == null) {
          // allow explicitly setting model attribute to null or undefined
          this[prop.key] = prop.value;
          return;
        }
        if (this[prop.key]) {
          this[prop.key].update(prop.value);
          return;
        }
        var ModelClass = prop.modelClass;
        this[prop.key] = new ModelClass(prop.value);
      }
    }, {
      key: "updateCollectionAttributeElement",
      value: function updateCollectionAttributeElement(attribute, elementProps) {
        // find existing version of the element in the collection
        var existingInstance = this[attribute.key].find(function (element) {
          return element[attribute.searchKey] === elementProps[attribute.searchKey];
        }); // if it exists in the collection, update it

        if (existingInstance) {
          existingInstance.update(elementProps);
          return existingInstance;
        } // if not, return a new instance

        var ModelClass = attribute.modelClass;
        return new ModelClass(elementProps);
      }
    }, {
      key: "updateModelCollectionAttribute",
      value: function updateModelCollectionAttribute(attribute) {
        var _this7 = this;

        // only includes updated values and removes any elements that were not
        // included in attribute.value
        return (attribute.value || []).map(function (element) {
          return _this7.updateCollectionAttributeElement(attribute, element);
        });
      }
    }, {
      key: "updateModelCollectionAttributes",
      value: function updateModelCollectionAttributes(propList) {
        var _this8 = this;
        propList.forEach(function (prop) {
          _this8[prop.key] = _this8.updateModelCollectionAttribute(prop);
        });
      }
    }], [{
      key: "defaultValueFor",
      value: function defaultValueFor(type) {
        var defaults = {
          string: '',
          number: '',
          "boolean": false,
          array: [],
          modelCollection: []
        };
        return defaults[type];
      }
    }, {
      key: "toCamelCase",
      value: function toCamelCase(s) {
        return s.replace(/(_[a-z])/g, function (subStr) {
          return subStr[1].toUpperCase();
        });
      }
    }, {
      key: "toSnakeCase",
      value: function toSnakeCase(s) {
        return s.replace(/([A-Z])/g, function (c) {
          return "_".concat(c.toLowerCase());
        });
      }
    }, {
      key: "getAttributeDefinition",
      value: function getAttributeDefinition() {
        return this._attributeDefinition;
      }
    }, {
      key: "attributeDefinition",
      get: function get() {
        return this.getAttributeDefinition();
      }
    }, {
      key: "_allAttributes",
      get: function get() {
        return Object.values(this.attributeDefinition);
      }
    }]);
    return _class;
  }(Base), _defineProperty(_class2, "_attributeDefinition", {}), _temp), (_applyDecoratedDescriptor(_class, "_attributeDefinition", [observable], (_init = Object.getOwnPropertyDescriptor(_class, "_attributeDefinition"), _init = _init ? _init.value : undefined, {
    enumerable: true,
    configurable: true,
    writable: true,
    initializer: function initializer() {
      return _init;
    }
  }), _class), _applyDecoratedDescriptor(_class.prototype, "allAttributes", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "allAttributes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "attributeDefinition", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "attributeDefinition"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_attributeMap", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "_attributeMap"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "attributes", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "attributes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "update", [action], Object.getOwnPropertyDescriptor(_class.prototype, "update"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateSimpleAttributes", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateSimpleAttributes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateModelAttribute", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateModelAttribute"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateCollectionAttributeElement", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateCollectionAttributeElement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateModelCollectionAttribute", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateModelCollectionAttribute"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateModelCollectionAttributes", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateModelCollectionAttributes"), _class.prototype)), _class;
};
var validatableMixin = function validatableMixin(Base) {
  var _class, _class2, _temp;
  return _class = (_temp = _class2 = /*#__PURE__*/function (_Base) {
    _inherits(_class, _Base);
    var _super = _createSuper(_class);
    function _class() {
      _classCallCheck(this, _class);
      return _super.apply(this, arguments);
    }
    _createClass(_class, [{
      key: "allValidators",
      value: function allValidators() {
        return Object.values(this.validatorDefinition);
      }
    }, {
      key: "selectValidators",
      value: function selectValidators(list) {
        var _this = this;
        if (!(list !== null && list !== void 0 && list.length)) return this.allValidators();
        return list.reduce(function (acc, key) {
          var validator = _this.validatorDefinition[key];
          if (validator) {
            acc.push(validator);
          }
          return acc;
        }, []);
      }
    }, {
      key: "isValid",
      get: function get() {
        return this.validate().length === 0;
      }
    }, {
      key: "failures",
      value: function failures() {
        var _this2 = this;
        return this.validations.map(function (validator) {
          return validator.failures(_this2);
        }).flat();
      }
    }, {
      key: "validate",
      value: function validate(attrs) {
        var _this3 = this;
        return this.selectValidators(attrs).map(function (validator) {
          if (!validator) return;
          if (typeof validator.validate === 'function') {
            return validator.validate();
          }
          var value = _this3[validator.key];
          if (!value) {
            return {
              key: validator.key,
              value: value,
              msg: validator.msg || _this3.constructor.blankErrorMsg
            };
          }
          if (validator.type === 'model' && 'validate' in value) {
            var v = value.validate();
            return v !== null && v !== void 0 && v.length ? {
              key: validator.key,
              type: 'model',
              value: v,
              msg: validator.msg || 'model has invalid properties'
            } : null;
          }
          if (validator.type === 'modelCollection') {
            if (!(value !== null && value !== void 0 && value.length)) return {
              key: validator.key,
              type: 'modelCollection',
              value: value,
              msg: validator.msg || _this3.constructor.blankErrorMsg
            };
            var nestedValidation = value.map(function (item) {
              if (!('validate' in item)) return;
              var invalids = item.validate();
              if (Array.isArray(invalids) && !invalids.length) return;
              return invalids;
            }).filter(Boolean);
            return nestedValidation !== null && nestedValidation !== void 0 && nestedValidation.length ? {
              key: validator.key,
              type: 'modelCollection',
              value: nestedValidation,
              msg: validator.msg || 'modelCollection has invalid models'
            } : null;
          }
          return null;
        }).filter(Boolean);
      }
    }]);
    return _class;
  }(Base), _defineProperty(_class2, "blankErrorMsg", 'should not be blank'), _temp), (_applyDecoratedDescriptor(_class.prototype, "failures", [action], Object.getOwnPropertyDescriptor(_class.prototype, "failures"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "validate"), _class.prototype)), _class;
};
var loadingStatusCollectionMixin = function loadingStatusCollectionMixin(Base) {
  var _class, _descriptor, _descriptor2;
  return _class = /*#__PURE__*/function (_Base) {
    _inherits(_class, _Base);
    var _super = _createSuper(_class);
    function _class() {
      var _this;
      _classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _initializerDefineProperty(_assertThisInitialized(_this), "_pending", _descriptor, _assertThisInitialized(_this));
      _initializerDefineProperty(_assertThisInitialized(_this), "_loaded", _descriptor2, _assertThisInitialized(_this));
      return _this;
    }
    _createClass(_class, [{
      key: "pending",
      get: function get() {
        return _toConsumableArray(this._pending.keys());
      }
    }, {
      key: "loaded",
      get: function get() {
        return _toConsumableArray(this._loaded.keys());
      }
    }, {
      key: "isPending",
      value: function isPending(id) {
        return this._pending.has(id);
      }
    }, {
      key: "isLoaded",
      value: function isLoaded(id) {
        return this._loaded.has(id);
      }
    }, {
      key: "setPending",
      value: function setPending(id, isPending) {
        if (isPending) {
          this._pending.set(id, true);
          return;
        }
        this._pending["delete"](id);
      }
    }, {
      key: "setLoaded",
      value: function setLoaded(id, isLoaded) {
        if (isLoaded) {
          this._loaded.set(id, true);
          return;
        }
        this._loaded["delete"](id);
      }
    }, {
      key: "finishPending",
      value: function finishPending(id) {
        this.setPending(id, false);
        this.setLoaded(id, true);
      }
    }]);
    return _class;
  }(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_pending", [observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return new Map();
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_loaded", [observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return new Map();
    }
  }), _applyDecoratedDescriptor(_class.prototype, "pending", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pending"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loaded", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "loaded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPending", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPending"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setLoaded", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setLoaded"), _class.prototype)), _class;
};
var Failure = /*#__PURE__*/function () {
  function Failure() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Failure);
    this.key = options.key;
    this.value = options.value;
    this.fullMessage = options.fullMessage;
    this.attributeLabel = options.attributeLabel;
    this.description = options.description;
    this.subFailure = options.subFailure;
  }
  _createClass(Failure, [{
    key: "msg",
    get: function get() {
      return this.message;
    }
  }, {
    key: "message",
    get: function get() {
      if (this.fullMessage) return this.fullMessage;
      var attributeLabel = this.attributeLabel,
        description = this.description;
      if (this.subFailure) {
        description = this.subFailure.message || this.subFailure.description;
        if (!this.subFailure.message) {
          attributeLabel += " ".concat(this.subFailure.attributeLabel);
        }
      }
      return "".concat(attributeLabel, " ").concat(description);
    }
  }], [{
    key: "newFrom",
    value: function newFrom(validation, model) {
      var failure = new Failure({
        key: validation.attribute,
        attributeLabel: validation.attributeLabel,
        value: validation.value(model)
      });
      if (validation.options.fullMessage) {
        failure.fullMessage = validation.options.fullMessage;
      } else {
        failure.attributeLabel = validation.attributeLabel;
        failure.description = validation.description;
      }
      return failure;
    }
  }]);
  return Failure;
}();
var AbstractValidation = /*#__PURE__*/function () {
  function AbstractValidation(attribute) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, AbstractValidation);
    this.attribute = attribute;
    this.options = options;
  }
  _createClass(AbstractValidation, [{
    key: "attributeLabel",
    get: function get() {
      if (this.options.attributeLabel) return this.options.attributeLabel;
      return this.attribute.replace(/^\w/, function (name) {
        return name.toUpperCase();
      });
    }
  }, {
    key: "description",
    get: function get() {
      return this.options.description || this.defaultDescription;
    }
  }, {
    key: "value",
    value: function value(model) {
      return model[this.attribute];
    }
  }, {
    key: "failures",
    value: function failures(model) {
      var _this = this;
      var value = this.value(model);
      var failures = [];
      var myFailure = this.failure(model);
      if (myFailure) {
        failures.push(myFailure);
      }
      if (value && this.constructor.isValidatable(value)) {
        failures = failures.concat(value.failures().map(function (failure) {
          return _this.adopt(failure);
        }));
      }
      return failures;
    }
  }, {
    key: "adopt",
    value: function adopt(failure) {
      return new Failure({
        key: this.attribute,
        attributeLabel: this.attributeLabel,
        subFailure: failure
      });
    }
  }], [{
    key: "isValidatable",
    value: function isValidatable(object) {
      return _typeof(object) === 'object' && 'failures' in object && 'validations' in object;
    }
  }]);
  return AbstractValidation;
}();
var IncompatibleUnitsError = /*#__PURE__*/function (_IF2JsModelError) {
  _inherits(IncompatibleUnitsError, _IF2JsModelError);
  var _super = _createSuper(IncompatibleUnitsError);
  function IncompatibleUnitsError(units1, units2) {
    _classCallCheck(this, IncompatibleUnitsError);
    return _super.call(this, "Units '".concat(units1, "' and '").concat(units2, "' are not compatible"));
  }
  return IncompatibleUnitsError;
}(IF2JsModelError);
var MissingQuantityError = /*#__PURE__*/function (_IF2JsModelError) {
  _inherits(MissingQuantityError, _IF2JsModelError);
  var _super = _createSuper(MissingQuantityError);
  function MissingQuantityError() {
    _classCallCheck(this, MissingQuantityError);
    return _super.call(this, 'Missing required quantity');
  }
  return MissingQuantityError;
}(IF2JsModelError);
var _class$f;
var Quantity = (_class$f = /*#__PURE__*/function (_Mix) {
  _inherits(Quantity, _Mix);
  var _super = _createSuper(Quantity);
  function Quantity(value) {
    var _this;
    _classCallCheck(this, Quantity);
    _this = _super.call(this, value);
    _this.update(value);
    return _this;
  }
  _createClass(Quantity, [{
    key: "displayValue",
    get: function get() {
      return this.constructor.format(this.scalar, this.units, {
        formatUnits: true
      });
    }
  }, {
    key: "isBlank",
    get: function get() {
      return this.displayValue === '';
    }
  }, {
    key: "numeratorUnits",
    get: function get() {
      return new Qty({
        scalar: 1,
        numerator: this.toQty().numerator
      }).units();
    }
  }, {
    key: "update",
    value: function update(rawValue) {
      var value = rawValue;
      if (!value && value !== 0) {
        this.scalar = '';
        this.units = '';
        return this;
      }
      if (typeof value.toJS === 'function') {
        value = rawValue.toJS();
      }
      if (typeof value.toLowerCase === 'function' && value.toLowerCase().includes('dry')) {
        this.scalar = 1;
        this.units = 'Dry';
        return this;
      }
      if (typeof value.replace === 'function') {
        value = value.replace(/\/100 gal/, '/hgal');
      }
      try {
        if (value !== 0 && value !== '0' && !value) {
          this.scalar = '';
          this.units = '';
          return this;
        }
        if (value && typeof value.match === 'function') {
          var fractionMatches = value.match(/^([0-9]+)\/([0-9]+)/);
          if (fractionMatches) {
            var scalar = fractionMatches[1] / fractionMatches[2];
            value = value.replace(fractionMatches[0], scalar.toString());
          }
        }
        var qty = Qty(value);
        this.scalar = qty.scalar;
        this.units = qty.units();
      } catch (e) {
        if (!(e instanceof Qty.Error)) {
          throw e;
        }
        this.logger.info("Ignoring bad/unknown quantity: ".concat(rawValue));
      }
      return this;
    }
  }, {
    key: "updateScalar",
    value: function updateScalar(value) {
      if (!value && value !== 0) {
        this.scalar = '';
        return;
      }
      this.scalar = Number(value);
    }
  }, {
    key: "format",
    value: function format(options) {
      return this.constructor.format(this.scalar, this.units, options);
    }
  }, {
    key: "compareTo",
    value: function compareTo(other) {
      if (!this.constructor.isQuantity(other)) {
        return this.compareTo(new Quantity(other));
      }
      if (other.isBlank) {
        throw new MissingQuantityError();
      }
      var qty = this.toQty();
      var otherQty = other.toQty();
      if (!qty.isCompatible(otherQty)) {
        throw new IncompatibleUnitsError(qty.units(), otherQty.units());
      }
      if (Math.abs(qty.baseScalar - otherQty.baseScalar) <= 0.0000000001) {
        return 0;
      }
      if (qty.baseScalar < otherQty.baseScalar) {
        return -1;
      }
      if (qty.baseScalar > otherQty.baseScalar) {
        return 1;
      }
    }
  }, {
    key: "eq",
    value: function eq(other) {
      try {
        return this.compareTo(other) === 0;
      } catch (error) {
        if (error instanceof MissingQuantityError) {
          if (other === undefined || other === null) {
            return false;
          }
          if (this.isBlank) {
            return true;
          }
          return false;
        }
        if (error instanceof IncompatibleUnitsError) {
          return false;
        }
        throw error;
      }
    }
  }, {
    key: "gt",
    value: function gt(other) {
      return this.compareTo(other) === 1;
    }
  }, {
    key: "gte",
    value: function gte(other) {
      return this.compareTo(other) >= 0;
    }
  }, {
    key: "lt",
    value: function lt(other) {
      return this.compareTo(other) === -1;
    }
  }, {
    key: "lte",
    value: function lte(other) {
      return this.compareTo(other) <= 0;
    }
  }, {
    key: "mul",
    value: function mul(other) {
      var isQty = other instanceof Quantity;
      if (this.scalar === '' || isQty && other.scalar === '' || other === '' || !other) {
        return new this.constructor('');
      }
      return new this.constructor(this.toQty().mul(this.constructor.isQuantity(other) ? other.toQty() : other).toString());
    }
  }, {
    key: "add",
    value: function add(other) {
      var isQty = other instanceof Object;
      var qty = Qty(this.scalar, this.units).add(isQty ? Qty(other.scalar, other.units) : other);
      return new this.constructor(qty.toString());
    }
  }, {
    key: "div",
    value: function div(other) {
      var isQty = other instanceof Quantity;
      if (this.scalar === '' || isQty && other.scalar === '' || other === '' || !other) {
        return new this.constructor('');
      }
      var qty = Qty(this.scalar, this.units).div(isQty ? Qty(other.scalar, other.units) : other);
      return new this.constructor(qty.toString());
    }
  }, {
    key: "isCompatible",
    value: function isCompatible(other) {
      return this.toQty().isCompatible(this.constructor.isQuantity(other) ? other.toQty() : other);
    }
  }, {
    key: "isZero",
    value: function isZero() {
      return this.scalar === 0 || this.scalar === '0';
    }
  }, {
    key: "kind",
    value: function kind(other) {
      var isQty = other instanceof Object;
      return Qty(this.scalar, this.units).kind(isQty ? Qty(other.scalar, other.units) : other);
    }
  }, {
    key: "to",
    value: function to(unit) {
      return new this.constructor(Qty(this.toJS()).to(unit));
    }
  }, {
    key: "toJS",
    value: function toJS() {
      return this.format({
        precise: true
      });
    }
  }, {
    key: "toQty",
    value: function toQty() {
      if (this.units === 'Dry') {
        return Qty(30, 'min');
      }
      if (!this.scalar && this.scalar !== 0) {
        return Qty(this.units);
      }
      return Qty(this.scalar, this.units);
    }
  }], [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      return {
        scalar: {
          name: 'Scalar',
          key: 'scalar',
          type: 'string'
        },
        units: {
          name: 'Units',
          key: 'units',
          type: 'string'
        }
      };
    }
  }, {
    key: "displayValue",
    value: function displayValue(q) {
      return this.isQuantity(q) ? q.displayValue : '';
    }
  }, {
    key: "isCompatible",
    value: function isCompatible(q1, q2) {
      var _this2;
      return this.isQuantity(q1) ? q1.isCompatible(q2) : (_this2 = new this(q1)) === null || _this2 === void 0 ? void 0 : _this2.isCompatible(q2);
    }
  }, {
    key: "isQuantity",
    value: function isQuantity(q) {
      return q instanceof Quantity;
    }
  }, {
    key: "isQuantityTruthy",
    value: function isQuantityTruthy(q) {
      return this.isQuantity(q) && !q.isBlank && !this.isZero(q);
    }
  }, {
    key: "isZero",
    value: function isZero(val) {
      if (val === 0 || val === '0') return true;
      if (!Quantity.isQuantity(val)) {
        var q = new Quantity(val);
        return q.isZero();
      }
      return val.isZero();
    }
  }, {
    key: "format",
    value: function format(scalar, units, options) {
      if (scalar === 1 && units === 'Dry') {
        return 'Dry';
      }
      return [].concat(scalar === 0 ? scalar : this.formatScalar(scalar, options) || []).concat((options !== null && options !== void 0 && options.formatUnits ? this.formatUnits(units) : units) || []).join(' ');
    }
  }, {
    key: "formatScalar",
    value: function formatScalar(scalar, options) {
      var _ref = options || {},
        digits = _ref.digits;
      var _ref2 = options || {},
        fixed = _ref2.fixed,
        precise = _ref2.precise;
      if (Number.isFinite(scalar)) {
        if (precise) {
          return Number(scalar);
        }
        digits = digits === 0 ? 0 : digits || 2;
        var value = scalar.toFixed(digits);
        if (fixed) {
          return value;
        }
        return Number(value);
      }
      return scalar || '';
    }
  }, {
    key: "formatUnits",
    value: function formatUnits(units) {
      var formattedUnits = units || '';
      formattedUnits = formattedUnits.replace(/1\/acre/, '/acre');
      formattedUnits = formattedUnits.replace(/\/hgal/, '/100 gal');
      return formattedUnits;
    }
  }, {
    key: "toQty",
    value: function toQty(q) {
      return Qty(q);
    }
  }, {
    key: "max",
    value: function max() {
      var _this3 = this;
      for (var _len = arguments.length, quantities = new Array(_len), _key = 0; _key < _len; _key++) {
        quantities[_key] = arguments[_key];
      }
      var validQuantities = [].concat(quantities).filter(function (q) {
        return q && _this3.isQuantity(q) && q.toJS();
      });
      return validQuantities.length ? validQuantities.reduce(function (max, quantity) {
        return quantity.gte(max) ? quantity : max;
      }) : new this('');
    }
  }]);
  return Quantity;
}(Mix(updatableMixin, loggableMixin)), (_applyDecoratedDescriptor(_class$f.prototype, "displayValue", [computed], Object.getOwnPropertyDescriptor(_class$f.prototype, "displayValue"), _class$f.prototype), _applyDecoratedDescriptor(_class$f.prototype, "isBlank", [computed], Object.getOwnPropertyDescriptor(_class$f.prototype, "isBlank"), _class$f.prototype), _applyDecoratedDescriptor(_class$f.prototype, "update", [action], Object.getOwnPropertyDescriptor(_class$f.prototype, "update"), _class$f.prototype), _applyDecoratedDescriptor(_class$f.prototype, "updateScalar", [action], Object.getOwnPropertyDescriptor(_class$f.prototype, "updateScalar"), _class$f.prototype)), _class$f);
var Presence = /*#__PURE__*/function (_AbstractValidation) {
  _inherits(Presence, _AbstractValidation);
  var _super = _createSuper(Presence);
  function Presence() {
    var _this;
    _classCallCheck(this, Presence);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.defaultDescription = 'must not be blank';
    return _this;
  }
  _createClass(Presence, [{
    key: "failure",
    value: function failure(model) {
      var value = this.value(model);
      var condition;
      if (!this.options.onlyIf || this.options.onlyIf()) {
        if (Quantity.isQuantity(value)) {
          condition = !Quantity.isQuantityTruthy(value);
        } else {
          condition = value === undefined || value === null || value.length === 0;
        }
        if (condition) {
          return Failure.newFrom(this, model);
        }
      }
    }
  }]);
  return Presence;
}(AbstractValidation);
var QuantityComparison = /*#__PURE__*/function (_AbstractValidation) {
  _inherits(QuantityComparison, _AbstractValidation);
  var _super = _createSuper(QuantityComparison);
  function QuantityComparison() {
    _classCallCheck(this, QuantityComparison);
    return _super.apply(this, arguments);
  }
  _createClass(QuantityComparison, [{
    key: "failureDescription",
    value: function failureDescription(model) {
      var value = this.value(model);
      if (this.options.optional && !value) return null;
      if (this.fails('gt', value)) return "must be greater than ".concat(this.optionDisplayValue('gt'));
      if (this.fails('gte', value)) return "must be greater than or equal to ".concat(this.optionDisplayValue('gte'));
      if (this.fails('lt', value)) return "must be less than ".concat(this.optionDisplayValue('lt'));
      if (this.fails('lte', value)) return "must be less than or equal to ".concat(this.optionDisplayValue('lte'));
      return null;
    }
  }, {
    key: "failure",
    value: function failure(model) {
      var description = this.failureDescription(model);
      if (description) {
        var failure = Failure.newFrom(this, model);
        failure.description = this.options.description || description;
        return failure;
      }
    }
  }, {
    key: "optionDisplayValue",
    value: function optionDisplayValue(option) {
      if (Quantity.isQuantity(this.options[option])) return this.options[option].displayValue;
      return this.options[option];
    }
  }, {
    key: "optionIsSet",
    value: function optionIsSet(option) {
      return this.options[option] !== undefined && this.options[option] !== null;
    }
  }, {
    key: "fails",
    value: function fails(quantityComparison, value) {
      if (!this.optionIsSet(quantityComparison)) return false;
      if (!value) return true;
      if (!Quantity.isQuantity(value)) return true;
      var compareWith = this.options[quantityComparison];
      if (Quantity.isQuantity(compareWith)) {
        return !value[quantityComparison](compareWith);
      }
      if (quantityComparison === 'gt') return !(value.scalar > compareWith);
      if (quantityComparison === 'gte') return !(value.scalar >= compareWith);
      if (quantityComparison === 'lt') return !(value.scalar < compareWith);
      if (quantityComparison === 'lte') return !(value.scalar <= compareWith);
    }
  }]);
  return QuantityComparison;
}(AbstractValidation);
var UpdatableBase = /*#__PURE__*/function (_Mix) {
  _inherits(UpdatableBase, _Mix);
  var _super = _createSuper(UpdatableBase);
  function UpdatableBase(props) {
    var _this;
    _classCallCheck(this, UpdatableBase);
    _this = _super.call(this, props);
    _this.update(props);
    return _this;
  }
  return UpdatableBase;
}(Mix(updatableMixin));
var ModelReference = /*#__PURE__*/function (_MixInto) {
  _inherits(ModelReference, _MixInto);
  var _super = _createSuper(ModelReference);
  function ModelReference() {
    _classCallCheck(this, ModelReference);
    return _super.apply(this, arguments);
  }
  _createClass(ModelReference, null, [{
    key: "fromModel",
    value: function fromModel(model) {
      return new this({
        id: model.id,
        type: model.type,
        name: model.name
      });
    }
  }, {
    key: "fromModelArray",
    value: function fromModelArray(modelArray) {
      var _this = this;
      return modelArray.map(function (m) {
        return _this.fromModel(m);
      });
    }
  }]);
  return ModelReference;
}(MixInto(UpdatableBase, idAttributeMixin, nameAttributeMixin, typeAttributeMixin, validatableMixin));
var AccountReference = /*#__PURE__*/function (_MixInto) {
  _inherits(AccountReference, _MixInto);
  var _super = _createSuper(AccountReference);
  function AccountReference() {
    _classCallCheck(this, AccountReference);
    return _super.apply(this, arguments);
  }
  _createClass(AccountReference, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(AccountReference), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: 'IF2::Account'
        }),
        fullName: {
          name: 'Full Name',
          key: 'fullName',
          type: 'string'
        }
      });
    }
  }, {
    key: "fromAccount",
    value: function fromAccount(account) {
      return new AccountReference({
        id: account.id,
        serial: account.serial,
        name: account.name,
        fullName: account.fullName
      });
    }
  }, {
    key: "fromModel",
    value: function fromModel(model) {
      return this.fromAccount(model);
    }
  }, {
    key: "isAccountReference",
    value: function isAccountReference(maybeRef) {
      return maybeRef instanceof AccountReference;
    }
  }]);
  return AccountReference;
}(MixInto(ModelReference, serialAttributeMixin));
var _class$e;
var AccountWithPath = (_class$e = /*#__PURE__*/function (_AccountReference) {
  _inherits(AccountWithPath, _AccountReference);
  var _super = _createSuper(AccountWithPath);
  function AccountWithPath() {
    _classCallCheck(this, AccountWithPath);
    return _super.apply(this, arguments);
  }
  _createClass(AccountWithPath, [{
    key: "clientPathString",
    get: function get() {
      var _this = this;
      return this.clientPath.filter(function (a) {
        return a.id !== _this.id;
      }).map(function (ancestor) {
        return ancestor.name;
      }).concat(this.name || []).join(': ');
    }
  }], [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      return _objectSpread2(_objectSpread2({}, _get(_getPrototypeOf(AccountWithPath), "getAttributeDefinition", this).call(this)), {}, {
        clientPath: {
          name: 'Client Path',
          key: 'clientPath',
          type: 'modelCollection',
          modelClass: AccountReference
        }
      });
    }
  }, {
    key: "fromAccount",
    value: function fromAccount(account) {
      return new AccountWithPath({
        id: account.id,
        serial: account.serial,
        name: account.name,
        fullName: account.fullName,
        clientPath: account.clientPath
      });
    }
  }, {
    key: "fromModel",
    value: function fromModel(model) {
      return this.fromAccount(model);
    }
  }, {
    key: "isAccountWithPath",
    value: function isAccountWithPath(maybeRef) {
      return maybeRef instanceof AccountWithPath;
    }
  }]);
  return AccountWithPath;
}(AccountReference), _applyDecoratedDescriptor(_class$e.prototype, "clientPathString", [computed], Object.getOwnPropertyDescriptor(_class$e.prototype, "clientPathString"), _class$e.prototype), _class$e);
var ModeOfAction = /*#__PURE__*/function (_MixInto) {
  _inherits(ModeOfAction, _MixInto);
  var _super = _createSuper(ModeOfAction);
  function ModeOfAction() {
    _classCallCheck(this, ModeOfAction);
    return _super.apply(this, arguments);
  }
  _createClass(ModeOfAction, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(ModeOfAction), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: this.type
        }),
        action: {
          name: 'Action',
          key: 'action',
          type: 'string'
        },
        groupNumber: {
          name: 'Group Number',
          key: 'groupNumber',
          type: 'string'
        },
        description: {
          name: 'Description',
          key: 'description',
          type: 'string'
        }
      });
    }
  }]);
  return ModeOfAction;
}(MixInto(UpdatableBase, idAttributeMixin, typeAttributeMixin));
_defineProperty(ModeOfAction, "type", 'IF2::ModeOfAction');
var ActiveIngredient = /*#__PURE__*/function (_MixInto) {
  _inherits(ActiveIngredient, _MixInto);
  var _super = _createSuper(ActiveIngredient);
  function ActiveIngredient() {
    _classCallCheck(this, ActiveIngredient);
    return _super.apply(this, arguments);
  }
  _createClass(ActiveIngredient, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(ActiveIngredient), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: this.type
        }),
        shortName: {
          name: 'Short Name',
          key: 'shortName',
          type: 'string'
        },
        cas: {
          name: 'CAS',
          key: 'cas',
          type: 'string'
        },
        pcCode: {
          name: 'PC Code',
          key: 'pcCode',
          type: 'string'
        },
        percent: {
          name: 'Percent',
          key: 'percent',
          type: 'string'
        },
        modesOfAction: {
          name: 'Mode of Action',
          key: 'modesOfAction',
          type: 'modelCollection',
          modelClass: ModeOfAction
        },
        toxicityClass: {
          name: 'Toxicity Class',
          key: 'toxicityClass',
          type: 'string'
        },
        toxicityCategory: {
          name: 'Toxicity Category',
          key: 'toxicityCategory',
          type: 'string'
        },
        alternateNames: {
          name: 'Alternate Name',
          key: 'alternateNames',
          type: 'array'
        }
      });
    }
  }]);
  return ActiveIngredient;
}(MixInto(UpdatableBase, idAttributeMixin, nameAttributeMixin, typeAttributeMixin));
_defineProperty(ActiveIngredient, "type", 'IF2::ActiveIngredient');
var ContactInfoItem = /*#__PURE__*/function (_UpdatableBase) {
  _inherits(ContactInfoItem, _UpdatableBase);
  var _super = _createSuper(ContactInfoItem);
  function ContactInfoItem() {
    _classCallCheck(this, ContactInfoItem);
    return _super.apply(this, arguments);
  }
  _createClass(ContactInfoItem, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      return _objectSpread2(_objectSpread2({}, _get(_getPrototypeOf(ContactInfoItem), "getAttributeDefinition", this).call(this)), {}, {
        label: {
          name: 'Label',
          key: 'label',
          type: 'string'
        },
        primary: {
          name: 'Primary',
          key: 'primary',
          type: 'boolean'
        }
      });
    }
  }]);
  return ContactInfoItem;
}(UpdatableBase);
var ContactAddress = /*#__PURE__*/function (_ContactInfoItem) {
  _inherits(ContactAddress, _ContactInfoItem);
  var _super = _createSuper(ContactAddress);
  function ContactAddress() {
    _classCallCheck(this, ContactAddress);
    return _super.apply(this, arguments);
  }
  _createClass(ContactAddress, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      return _objectSpread2(_objectSpread2({}, _get(_getPrototypeOf(ContactAddress), "getAttributeDefinition", this).call(this)), {}, {
        value: {
          name: 'Value',
          key: 'value',
          type: 'string'
        }
      });
    }
  }]);
  return ContactAddress;
}(ContactInfoItem);
var ContactEmail = /*#__PURE__*/function (_ContactInfoItem) {
  _inherits(ContactEmail, _ContactInfoItem);
  var _super = _createSuper(ContactEmail);
  function ContactEmail() {
    _classCallCheck(this, ContactEmail);
    return _super.apply(this, arguments);
  }
  _createClass(ContactEmail, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      return _objectSpread2(_objectSpread2({}, _get(_getPrototypeOf(ContactEmail), "getAttributeDefinition", this).call(this)), {}, {
        address: {
          name: 'Address',
          key: 'address',
          type: 'string'
        }
      });
    }
  }]);
  return ContactEmail;
}(ContactInfoItem);
var ContactPhone = /*#__PURE__*/function (_ContactInfoItem) {
  _inherits(ContactPhone, _ContactInfoItem);
  var _super = _createSuper(ContactPhone);
  function ContactPhone() {
    _classCallCheck(this, ContactPhone);
    return _super.apply(this, arguments);
  }
  _createClass(ContactPhone, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      return _objectSpread2(_objectSpread2({}, _get(_getPrototypeOf(ContactPhone), "getAttributeDefinition", this).call(this)), {}, {
        number: {
          name: 'Number',
          key: 'number',
          type: 'string'
        }
      });
    }
  }]);
  return ContactPhone;
}(ContactInfoItem);
var Sprayer = /*#__PURE__*/function (_MixInto) {
  _inherits(Sprayer, _MixInto);
  var _super = _createSuper(Sprayer);
  function Sprayer() {
    _classCallCheck(this, Sprayer);
    return _super.apply(this, arguments);
  }
  _createClass(Sprayer, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(Sprayer), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: this.type
        }),
        account: {
          name: 'Account',
          key: 'account',
          type: 'model',
          modelClass: AccountWithPath
        },
        licensePlateNumber: {
          name: 'License Plate Number',
          key: 'licensePlateNumber',
          type: 'string'
        },
        tankSize: {
          name: 'Tank Size',
          key: 'tankSize',
          type: 'model',
          modelClass: Quantity
        },
        notes: {
          name: 'Notes',
          key: 'notes',
          type: 'string'
        }
      });
    }
  }]);
  return Sprayer;
}(MixInto(UpdatableBase, idAttributeMixin, serialAttributeMixin, nameAttributeMixin, typeAttributeMixin));
_defineProperty(Sprayer, "type", 'IF2::Sprayer');
var Tractor = /*#__PURE__*/function (_MixInto) {
  _inherits(Tractor, _MixInto);
  var _super = _createSuper(Tractor);
  function Tractor() {
    _classCallCheck(this, Tractor);
    return _super.apply(this, arguments);
  }
  _createClass(Tractor, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(Tractor), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: this.type
        }),
        account: {
          name: 'Account',
          key: 'account',
          type: 'model',
          modelClass: AccountWithPath
        },
        licensePlateNumber: {
          name: 'License Plate Number',
          key: 'licensePlateNumber',
          type: 'string'
        },
        notes: {
          name: 'Notes',
          key: 'notes',
          type: 'string'
        }
      });
    }
  }]);
  return Tractor;
}(MixInto(UpdatableBase, idAttributeMixin, serialAttributeMixin, nameAttributeMixin, typeAttributeMixin));
_defineProperty(Tractor, "type", 'IF2::Tractor');
var _class$d, _class2$b, _temp$b;
var Contact = (_class$d = (_temp$b = _class2$b = /*#__PURE__*/function (_MixInto) {
  _inherits(Contact, _MixInto);
  var _super = _createSuper(Contact);
  function Contact() {
    _classCallCheck(this, Contact);
    return _super.apply(this, arguments);
  }
  _createClass(Contact, [{
    key: "name",
    get: function get() {
      return [].concat(this.firstName || []).concat(this.lastName || []).join(' ');
    }
  }, {
    key: "address",
    get: function get() {
      return (this.primaryAddress || {
        value: ''
      }).value;
    }
  }, {
    key: "primaryAddress",
    get: function get() {
      if (this.addresses.length < 1) {
        return new ContactAddress();
      }
      return this.addresses.find(function (address) {
        return address.primary;
      }) || this.addresses[0];
    }
  }, {
    key: "email",
    get: function get() {
      return (this.primaryEmail || {
        address: ''
      }).address;
    }
  }, {
    key: "primaryEmail",
    get: function get() {
      if (this.emails.length < 1) {
        return new ContactEmail();
      }
      return this.emails.find(function (email) {
        return email.primary;
      }) || this.hasEmail && this.emails[0];
    }
  }, {
    key: "phone",
    get: function get() {
      return (this.primaryPhone || {
        number: ''
      }).number;
    }
  }, {
    key: "primaryPhone",
    get: function get() {
      if (this.phones.length < 1) {
        return new ContactPhone();
      }
      return this.phones.find(function (phone) {
        return phone.primary;
      }) || this.phones[0];
    }
  }, {
    key: "fullText",
    get: function get() {
      return [this.firstName, this.lastName].concat(this.addresses.map(function (address) {
        return address.value;
      }), this.emails.map(function (email) {
        return email.address;
      }), this.phones.map(function (phone) {
        return phone.number;
      })).join(' ');
    }
  }, {
    key: "hasEmail",
    get: function get() {
      return this.emails.length > 0;
    }
  }], [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(Contact), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: this.type
        }),
        firstName: {
          name: 'First Name',
          key: 'firstName',
          type: 'string'
        },
        lastName: {
          name: 'Last Name',
          key: 'lastName',
          type: 'string'
        },
        licenseNumber: {
          name: 'License Number',
          key: 'licenseNumber',
          type: 'string'
        },
        addresses: {
          name: 'Address',
          key: 'addresses',
          type: 'modelCollection',
          modelClass: ContactAddress,
          searchKey: 'value'
        },
        emails: {
          name: 'Email',
          key: 'emails',
          type: 'modelCollection',
          modelClass: ContactEmail,
          searchKey: 'address'
        },
        phones: {
          name: 'Phone',
          key: 'phones',
          type: 'modelCollection',
          modelClass: ContactPhone,
          searchKey: 'number'
        },
        categories: {
          name: 'Categories',
          key: 'categories',
          type: 'array'
        },
        defaultSprayer: {
          name: 'Default Sprayer',
          key: 'defaultSprayer',
          type: 'model',
          modelClass: Sprayer
        },
        defaultTractor: {
          name: 'Default Tractor',
          key: 'defaultTractor',
          type: 'model',
          modelClass: Tractor
        }
      });
    }
  }]);
  return Contact;
}(MixInto(UpdatableBase, idAttributeMixin, typeAttributeMixin)), _defineProperty(_class2$b, "type", 'IF2::Contact'), _defineProperty(_class2$b, "sortByLastName", function (contact1, contact2) {
  return naturalSort(contact1.lastName.toLowerCase(), contact2.lastName.toLowerCase());
}), _temp$b), (_applyDecoratedDescriptor(_class$d.prototype, "name", [computed], Object.getOwnPropertyDescriptor(_class$d.prototype, "name"), _class$d.prototype), _applyDecoratedDescriptor(_class$d.prototype, "address", [computed], Object.getOwnPropertyDescriptor(_class$d.prototype, "address"), _class$d.prototype), _applyDecoratedDescriptor(_class$d.prototype, "primaryAddress", [computed], Object.getOwnPropertyDescriptor(_class$d.prototype, "primaryAddress"), _class$d.prototype), _applyDecoratedDescriptor(_class$d.prototype, "email", [computed], Object.getOwnPropertyDescriptor(_class$d.prototype, "email"), _class$d.prototype), _applyDecoratedDescriptor(_class$d.prototype, "primaryEmail", [computed], Object.getOwnPropertyDescriptor(_class$d.prototype, "primaryEmail"), _class$d.prototype), _applyDecoratedDescriptor(_class$d.prototype, "phone", [computed], Object.getOwnPropertyDescriptor(_class$d.prototype, "phone"), _class$d.prototype), _applyDecoratedDescriptor(_class$d.prototype, "primaryPhone", [computed], Object.getOwnPropertyDescriptor(_class$d.prototype, "primaryPhone"), _class$d.prototype), _applyDecoratedDescriptor(_class$d.prototype, "fullText", [computed], Object.getOwnPropertyDescriptor(_class$d.prototype, "fullText"), _class$d.prototype), _applyDecoratedDescriptor(_class$d.prototype, "hasEmail", [computed], Object.getOwnPropertyDescriptor(_class$d.prototype, "hasEmail"), _class$d.prototype)), _class$d);
var _class$c;
var GeoJSONBase = (_class$c = /*#__PURE__*/function (_Mix) {
  _inherits(GeoJSONBase, _Mix);
  var _super = _createSuper(GeoJSONBase);
  function GeoJSONBase() {
    _classCallCheck(this, GeoJSONBase);
    return _super.apply(this, arguments);
  }
  _createClass(GeoJSONBase, [{
    key: "jsonString",
    get: function get() {
      return JSON.stringify(this);
    }
  }], [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      return {
        type: {
          name: 'Type',
          key: 'type',
          type: 'string'
        }
      };
    }
  }]);
  return GeoJSONBase;
}(Mix(updatableMixin)), _applyDecoratedDescriptor(_class$c.prototype, "jsonString", [computed], Object.getOwnPropertyDescriptor(_class$c.prototype, "jsonString"), _class$c.prototype), _class$c);
var FeatureGeometryBase = /*#__PURE__*/function (_GeoJSONBase) {
  _inherits(FeatureGeometryBase, _GeoJSONBase);
  var _super = _createSuper(FeatureGeometryBase);
  function FeatureGeometryBase(props) {
    var _this;
    _classCallCheck(this, FeatureGeometryBase);
    _this = _super.call(this, props);
    _this.update(props);
    return _this;
  }
  _createClass(FeatureGeometryBase, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      return _objectSpread2(_objectSpread2({}, GeoJSONBase.getAttributeDefinition()), {}, {
        coordinates: {
          name: 'Coordinate',
          key: 'coordinates',
          type: 'array'
        }
      });
    }
  }]);
  return FeatureGeometryBase;
}(GeoJSONBase);
var PolygonGeometry = /*#__PURE__*/function (_FeatureGeometryBase) {
  _inherits(PolygonGeometry, _FeatureGeometryBase);
  var _super = _createSuper(PolygonGeometry);
  function PolygonGeometry() {
    _classCallCheck(this, PolygonGeometry);
    return _super.apply(this, arguments);
  }
  _createClass(PolygonGeometry, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = FeatureGeometryBase.getAttributeDefinition();
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: this.type
        })
      });
    }
  }]);
  return PolygonGeometry;
}(FeatureGeometryBase);
_defineProperty(PolygonGeometry, "type", 'Polygon');
var MultiPolygonGeometry = /*#__PURE__*/function (_FeatureGeometryBase) {
  _inherits(MultiPolygonGeometry, _FeatureGeometryBase);
  var _super = _createSuper(MultiPolygonGeometry);
  function MultiPolygonGeometry() {
    _classCallCheck(this, MultiPolygonGeometry);
    return _super.apply(this, arguments);
  }
  _createClass(MultiPolygonGeometry, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = FeatureGeometryBase.getAttributeDefinition();
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: this.type
        })
      });
    }
  }]);
  return MultiPolygonGeometry;
}(FeatureGeometryBase);
_defineProperty(MultiPolygonGeometry, "type", 'MultiPolygon');
var PointGeometry = /*#__PURE__*/function (_FeatureGeometryBase) {
  _inherits(PointGeometry, _FeatureGeometryBase);
  var _super = _createSuper(PointGeometry);
  function PointGeometry() {
    _classCallCheck(this, PointGeometry);
    return _super.apply(this, arguments);
  }
  _createClass(PointGeometry, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = FeatureGeometryBase.getAttributeDefinition();
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: this.type
        })
      });
    }
  }]);
  return PointGeometry;
}(FeatureGeometryBase);
_defineProperty(PointGeometry, "type", 'Point');
var FeatureGeometry = /*#__PURE__*/function (_FeatureGeometryBase) {
  _inherits(FeatureGeometry, _FeatureGeometryBase);
  var _super = _createSuper(FeatureGeometry);

  // Include as static property so that it can be overridden if necessary
  // Include as static property so that it can be overridden if necessary
  // Include as static property so that it can be overridden if necessary
  function FeatureGeometry(maybeProps) {
    var _this;
    _classCallCheck(this, FeatureGeometry);
    var props = maybeProps || {};
    _this = _super.call(this, props);
    if (!props.type) throw new Error('Not valid GeoJSON');
    switch (props.type) {
      case 'Point':
        return _possibleConstructorReturn(_this, new _this.constructor.PointGeometryClass(props));
      // case 'MultiPoint':
      //   return new Feature(props);
      // case 'LineString':
      //   return new Feature(props);
      // case 'MultiLineString':
      //   return new Feature(props);

      case 'Polygon':
        return _possibleConstructorReturn(_this, new _this.constructor.PolygonGeometryClass(props));
      case 'MultiPolygon':
        return _possibleConstructorReturn(_this, new _this.constructor.MultiPolygonGeometryClass(props));
      // case 'GeometryCollection':
      //   return new Feature(props);

      default:
        throw new UnsupportedGeometryTypeError(props.type);
    }
  }
  return FeatureGeometry;
}(FeatureGeometryBase);
_defineProperty(FeatureGeometry, "PointGeometryClass", PointGeometry);
_defineProperty(FeatureGeometry, "PolygonGeometryClass", PolygonGeometry);
_defineProperty(FeatureGeometry, "MultiPolygonGeometryClass", MultiPolygonGeometry);
var Feature = /*#__PURE__*/function (_GeoJSONBase) {
  _inherits(Feature, _GeoJSONBase);
  var _super = _createSuper(Feature);
  function Feature(props) {
    var _this;
    _classCallCheck(this, Feature);
    _this = _super.call(this, props);
    _this.update(props);
    return _this;
  }
  _createClass(Feature, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = GeoJSONBase.getAttributeDefinition();
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: this.type
        }),
        geometry: {
          name: 'Geometry',
          key: 'geometry',
          type: 'model',
          modelClass: FeatureGeometry
        },
        properties: {
          name: 'Properties',
          key: 'properties',
          type: 'object'
        }
      });
    }
  }]);
  return Feature;
}(GeoJSONBase);
_defineProperty(Feature, "type", 'Feature');
var _class$b, _class2$a, _temp$a;
var FeatureCollection = (_class$b = (_temp$a = _class2$a = /*#__PURE__*/function (_GeoJSONBase) {
  _inherits(FeatureCollection, _GeoJSONBase);
  var _super = _createSuper(FeatureCollection);
  function FeatureCollection(props) {
    var _this;
    _classCallCheck(this, FeatureCollection);
    _this = _super.call(this, props);
    _this.update(props);
    return _this;
  }
  _createClass(FeatureCollection, [{
    key: "updateCollectionAttributeElement",
    value: function updateCollectionAttributeElement(attribute, elementProps) {
      if (!['FeatureCollection', 'Feature'].includes(elementProps.type)) {
        return _get(_getPrototypeOf(FeatureCollection.prototype), "updateCollectionAttributeElement", this).call(this, attribute, elementProps);
      }
      var ModelClass;
      if (elementProps.type === 'FeatureCollection') {
        ModelClass = this.constructor.FeatureCollectionClass;
      } else {
        ModelClass = this.constructor.FeatureClass;
      }
      return new ModelClass(elementProps);
    }
  }], [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = GeoJSONBase.getAttributeDefinition();
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: 'FeatureCollection'
        }),
        features: {
          name: 'Feature',
          key: 'features',
          type: 'modelCollection' // modelClass could be either Feature or FeatureCollection.  This is
          // handled in overridden `updateCollectionAttributeElement` method below
        }
      });
    } // Include as static property so that it can be overridden if necessary
  }]);

  return FeatureCollection;
}(GeoJSONBase), _defineProperty(_class2$a, "type", 'FeatureCollection'), _defineProperty(_class2$a, "FeatureCollectionClass", _class2$a), _defineProperty(_class2$a, "FeatureClass", Feature), _temp$a), _applyDecoratedDescriptor(_class$b.prototype, "updateCollectionAttributeElement", [action], Object.getOwnPropertyDescriptor(_class$b.prototype, "updateCollectionAttributeElement"), _class$b.prototype), _class$b);
var FeatureBuilder = /*#__PURE__*/function (_GeoJSONBase) {
  _inherits(FeatureBuilder, _GeoJSONBase);
  var _super = _createSuper(FeatureBuilder);

  // Include as static property so that it can be overridden if necessary
  // Include as static property so that it can be overridden if necessary
  function FeatureBuilder(maybeProps) {
    var _this;
    _classCallCheck(this, FeatureBuilder);
    var props = maybeProps || {};
    _this = _super.call(this, props);
    if (!props.type) throw new InvalidGeoJsonError();
    switch (props.type) {
      case 'FeatureCollection':
        return _possibleConstructorReturn(_this, new _this.constructor.FeatureCollectionClass(props));
      case 'Feature':
        return _possibleConstructorReturn(_this, new _this.constructor.FeatureClass(props));
      default:
        throw new InvalidFeatureError();
    }
  }
  return FeatureBuilder;
}(GeoJSONBase);
_defineProperty(FeatureBuilder, "FeatureCollectionClass", FeatureCollection);
_defineProperty(FeatureBuilder, "FeatureClass", Feature);
var GeoJSON = /*#__PURE__*/function (_GeoJSONBase) {
  _inherits(GeoJSON, _GeoJSONBase);
  var _super = _createSuper(GeoJSON);

  // Include as static property so that it can be overridden if necessary
  // Include as static property so that it can be overridden if necessary
  function GeoJSON(maybeProps) {
    var _this;
    _classCallCheck(this, GeoJSON);
    var props = maybeProps || {
      type: 'FeatureCollection',
      features: []
    };
    if (typeof props === 'string') {
      props = JSON.parse(props);
    }
    _this = _super.call(this, props);
    if (!props.type) throw new InvalidGeoJsonError();
    if (props.type === 'FeatureCollection' || props.type === 'Feature') {
      return _possibleConstructorReturn(_this, new _this.constructor.FeatureBuilderClass(props));
    }
    return _possibleConstructorReturn(_this, new _this.constructor.FeatureGeometryClass(props));
  }
  return GeoJSON;
}(GeoJSONBase);
_defineProperty(GeoJSON, "FeatureBuilderClass", FeatureBuilder);
_defineProperty(GeoJSON, "FeatureGeometryClass", FeatureGeometry);
var FieldCropVariety = /*#__PURE__*/function (_MixInto) {
  _inherits(FieldCropVariety, _MixInto);
  var _super = _createSuper(FieldCropVariety);
  function FieldCropVariety() {
    _classCallCheck(this, FieldCropVariety);
    return _super.apply(this, arguments);
  }
  _createClass(FieldCropVariety, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      return _objectSpread2(_objectSpread2({}, _get(_getPrototypeOf(FieldCropVariety), "getAttributeDefinition", this).call(this)), {}, {
        percent: {
          name: 'Percent',
          key: 'percent',
          type: 'string'
        }
      });
    }
  }]);
  return FieldCropVariety;
}(MixInto(UpdatableBase, nameAttributeMixin));
var FieldCropCultivar = /*#__PURE__*/function (_MixInto) {
  _inherits(FieldCropCultivar, _MixInto);
  var _super = _createSuper(FieldCropCultivar);
  function FieldCropCultivar() {
    _classCallCheck(this, FieldCropCultivar);
    return _super.apply(this, arguments);
  }
  _createClass(FieldCropCultivar, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      return _objectSpread2(_objectSpread2({}, _get(_getPrototypeOf(FieldCropCultivar), "getAttributeDefinition", this).call(this)), {}, {
        variety: {
          name: 'Variety',
          key: 'variety',
          type: 'string'
        }
      });
    }
  }]);
  return FieldCropCultivar;
}(MixInto(UpdatableBase, nameAttributeMixin));
var FieldCropRootStock = /*#__PURE__*/function (_MixInto) {
  _inherits(FieldCropRootStock, _MixInto);
  var _super = _createSuper(FieldCropRootStock);
  function FieldCropRootStock() {
    _classCallCheck(this, FieldCropRootStock);
    return _super.apply(this, arguments);
  }
  _createClass(FieldCropRootStock, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      return _objectSpread2(_objectSpread2({}, _get(_getPrototypeOf(FieldCropRootStock), "getAttributeDefinition", this).call(this)), {}, {
        percent: {
          name: 'Percent',
          key: 'percent',
          type: 'string'
        }
      });
    }
  }]);
  return FieldCropRootStock;
}(MixInto(UpdatableBase, nameAttributeMixin));
var FieldCropReference = /*#__PURE__*/function (_MixInto) {
  _inherits(FieldCropReference, _MixInto);
  var _super = _createSuper(FieldCropReference);
  function FieldCropReference() {
    _classCallCheck(this, FieldCropReference);
    return _super.apply(this, arguments);
  }
  _createClass(FieldCropReference, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      return _objectSpread2(_objectSpread2({}, _get(_getPrototypeOf(FieldCropReference), "getAttributeDefinition", this).call(this)), {}, {
        varieties: {
          name: 'Variety',
          key: 'varieties',
          type: 'modelCollection',
          searchKey: 'name',
          modelClass: FieldCropVariety
        },
        cultivars: {
          name: 'Cultivar',
          key: 'cultivars',
          type: 'modelCollection',
          searchKey: 'id',
          modelClass: FieldCropCultivar
        },
        rootStocks: {
          name: 'Rootstock',
          key: 'rootStocks',
          type: 'modelCollection',
          searchKey: 'id',
          modelClass: FieldCropRootStock
        },
        useTypes: {
          name: 'Use Type',
          key: 'useTypes',
          type: 'array'
        }
      });
    }
  }]);
  return FieldCropReference;
}(MixInto(UpdatableBase, idAttributeMixin, nameAttributeMixin));
_defineProperty(FieldCropReference, "type", 'IF2::Crop');
var _class$a, _class2$9, _temp$9;
var Field = (_class$a = (_temp$9 = _class2$9 = /*#__PURE__*/function (_MixInto) {
  _inherits(Field, _MixInto);
  var _super = _createSuper(Field);
  function Field() {
    _classCallCheck(this, Field);
    return _super.apply(this, arguments);
  }
  _createClass(Field, [{
    key: "acreage",
    get: function get() {
      return this.area.displayValue;
    }
  }, {
    key: "acres",
    get: function get() {
      var _this$area;
      return ((_this$area = this.area) === null || _this$area === void 0 ? void 0 : _this$area.scalar) || 0;
    }
  }, {
    key: "clientPathFieldName",
    get: function get() {
      return [].concat(this.account.clientPathString || []).concat(this.name).join(': ');
    }
  }, {
    key: "countyName",
    get: function get() {
      if (!this.county) return null;
      if (this.county.match(/county/i)) return this.county;
      return "".concat(this.county, " County");
    }
  }, {
    key: "cropName",
    get: function get() {
      return this.crop.name || '';
    }
  }, {
    key: "fullText",
    get: function get() {
      return [this.clientPathFieldName, this.cropName, this.organic ? 'organic' : '', this.varieties.filter(function (v) {
        return !!v;
      }).map(function (v) {
        return v.name;
      }).join(' ')].filter(function (t) {
        return !!t;
      }).join(' ');
    }
  }, {
    key: "fullTextLowercase",
    get: function get() {
      return this.fullText.toLowerCase();
    }
  }, {
    key: "gps",
    get: function get() {
      if (!this.latitude && !this.longitude) return '';
      var lat = parseFloat(this.latitude).toFixed(4);
      var _long = parseFloat(this.longitude).toFixed(4);
      return "".concat(lat, ",").concat(_long);
    }
  }, {
    key: "textIndex",
    get: function get() {
      return [this.clientPathFieldName, this.cropName, this.organic ? 'organic' : '', this.varieties.filter(function (v) {
        return !!v;
      }).map(function (v) {
        return v.name;
      }).join(' ')].filter(function (t) {
        return !!t;
      }).join(' ').toLowerCase();
    }
  }, {
    key: "varieties",
    get: function get() {
      var _this$fieldVarieties;
      return (_this$fieldVarieties = this.fieldVarieties) !== null && _this$fieldVarieties !== void 0 && _this$fieldVarieties.length ? this.fieldVarieties : this.crop.varieties;
    }
  }, {
    key: "varietyNames",
    get: function get() {
      var sorted = this.varieties.slice().sort(function (a, b) {
        return a.percent === b.percent ? sortByName(a, b) : parseFloat(b.percent) - parseFloat(a.percent);
      });
      return sorted.map(function (each) {
        return each.name;
      }).join(', ');
    }
  }], [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(Field), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: this.type
        }),
        account: {
          name: 'Account',
          key: 'account',
          type: 'model',
          modelClass: AccountWithPath,
          defaultValue: new AccountWithPath()
        },
        crop: {
          name: 'Crop',
          key: 'crop',
          type: 'model',
          modelClass: FieldCropReference,
          defaultValue: new FieldCropReference()
        },
        /* fieldVarieties is a temporary name to avoid a name collision with the
        computed property 'varieties'. This is to accomodate for documents that still
        have their varieties on the crop model.
        We will change 'fieldVarieties' to 'varieties'
        when crop.varieties is obsolete. */
        fieldVarieties: {
          name: 'Variety',
          key: 'fieldVarieties',
          jsKey: 'varieties',
          type: 'modelCollection',
          searchKey: 'name',
          modelClass: FieldCropVariety
        },
        county: {
          name: 'County',
          key: 'county',
          type: 'string'
        },
        yearPlanted: {
          name: 'Year Planted',
          key: 'yearPlanted',
          type: 'string'
        },
        area: {
          name: 'Area',
          key: 'area',
          type: 'model',
          modelClass: Quantity,
          defaultValue: new Quantity('')
        },
        rowSpacing: {
          name: 'Row Spacing',
          key: 'rowSpacing',
          type: 'model',
          modelClass: Quantity,
          defaultValue: new Quantity('')
        },
        notes: {
          name: 'Notes',
          key: 'notes',
          type: 'string'
        },
        longitude: {
          name: 'Longitude',
          key: 'longitude',
          type: 'string'
        },
        latitude: {
          name: 'Latitude',
          key: 'latitude',
          type: 'string'
        },
        nonBearing: {
          name: 'Non Bearing',
          key: 'nonBearing',
          type: 'boolean'
        },
        geoJson: {
          name: 'GeoJSON',
          key: 'geoJson',
          type: 'model',
          modelClass: GeoJSON
        },
        organic: {
          name: 'Organic',
          key: 'organic',
          type: 'boolean'
        },
        organicDate: {
          name: 'Organic Date',
          key: 'organicDate',
          type: 'string'
        },
        accountingReference: {
          name: 'Accounting Reference',
          key: 'accountingReference',
          type: 'string'
        },
        inactive: {
          name: 'Inactive',
          key: 'inactive',
          type: 'boolean'
        }
      });
    }
  }]);
  return Field;
}(MixInto(UpdatableBase, idAttributeMixin, nameAttributeMixin, selectableMixin, serialAttributeMixin, timestampAttributesMixin, typeAttributeMixin, checkableMixin)), _defineProperty(_class2$9, "type", 'IF2::Field'), _temp$9), (_applyDecoratedDescriptor(_class$a.prototype, "acreage", [computed], Object.getOwnPropertyDescriptor(_class$a.prototype, "acreage"), _class$a.prototype), _applyDecoratedDescriptor(_class$a.prototype, "acres", [computed], Object.getOwnPropertyDescriptor(_class$a.prototype, "acres"), _class$a.prototype), _applyDecoratedDescriptor(_class$a.prototype, "clientPathFieldName", [computed], Object.getOwnPropertyDescriptor(_class$a.prototype, "clientPathFieldName"), _class$a.prototype), _applyDecoratedDescriptor(_class$a.prototype, "countyName", [computed], Object.getOwnPropertyDescriptor(_class$a.prototype, "countyName"), _class$a.prototype), _applyDecoratedDescriptor(_class$a.prototype, "cropName", [computed], Object.getOwnPropertyDescriptor(_class$a.prototype, "cropName"), _class$a.prototype), _applyDecoratedDescriptor(_class$a.prototype, "fullText", [computed], Object.getOwnPropertyDescriptor(_class$a.prototype, "fullText"), _class$a.prototype), _applyDecoratedDescriptor(_class$a.prototype, "fullTextLowercase", [computed], Object.getOwnPropertyDescriptor(_class$a.prototype, "fullTextLowercase"), _class$a.prototype), _applyDecoratedDescriptor(_class$a.prototype, "gps", [computed], Object.getOwnPropertyDescriptor(_class$a.prototype, "gps"), _class$a.prototype), _applyDecoratedDescriptor(_class$a.prototype, "textIndex", [computed], Object.getOwnPropertyDescriptor(_class$a.prototype, "textIndex"), _class$a.prototype), _applyDecoratedDescriptor(_class$a.prototype, "varieties", [computed], Object.getOwnPropertyDescriptor(_class$a.prototype, "varieties"), _class$a.prototype), _applyDecoratedDescriptor(_class$a.prototype, "varietyNames", [computed], Object.getOwnPropertyDescriptor(_class$a.prototype, "varietyNames"), _class$a.prototype)), _class$a);
var FieldCompletion = /*#__PURE__*/function (_MixInto) {
  _inherits(FieldCompletion, _MixInto);
  var _super = _createSuper(FieldCompletion);
  function FieldCompletion() {
    _classCallCheck(this, FieldCompletion);
    return _super.apply(this, arguments);
  }
  _createClass(FieldCompletion, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(FieldCompletion), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: this.type
        }),
        applicationId: {
          name: 'Application ID',
          key: 'applicationId',
          type: 'number'
        },
        field: {
          name: 'Field',
          key: 'field',
          type: 'model',
          modelClass: Field,
          defaultValue: new Field()
        },
        acres: {
          name: 'Acres',
          key: 'acres',
          type: 'number'
        },
        percentage: {
          name: 'Percentage',
          key: 'percentage',
          type: 'number'
        },
        coveragePercentage: {
          name: 'Coverage Percentage',
          key: 'coveragePercentage',
          type: 'number'
        }
      });
    }
  }]);
  return FieldCompletion;
}(MixInto(UpdatableBase, idAttributeMixin, serialAttributeMixin, typeAttributeMixin));
_defineProperty(FieldCompletion, "type", 'IF2::SprayRecord::FieldCompletion');
var FieldReference = /*#__PURE__*/function (_ModelReference) {
  _inherits(FieldReference, _ModelReference);
  var _super = _createSuper(FieldReference);
  function FieldReference() {
    _classCallCheck(this, FieldReference);
    return _super.apply(this, arguments);
  }
  _createClass(FieldReference, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(FieldReference), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: 'IF2::Field'
        }),
        crop: {
          name: 'Crop',
          key: 'crop',
          type: 'model',
          modelClass: ModelReference,
          defaultValue: new ModelReference()
        }
      });
    }
  }]);
  return FieldReference;
}(ModelReference);
var Formulation = /*#__PURE__*/function (_MixInto) {
  _inherits(Formulation, _MixInto);
  var _super = _createSuper(Formulation);
  function Formulation() {
    _classCallCheck(this, Formulation);
    return _super.apply(this, arguments);
  }
  _createClass(Formulation, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      return _objectSpread2(_objectSpread2({}, _get(_getPrototypeOf(Formulation), "getAttributeDefinition", this).call(this)), {}, {
        description: {
          name: 'Description',
          key: 'description',
          type: 'string'
        },
        baseUnit: {
          name: 'Base Unit',
          key: 'baseUnit',
          type: 'string'
        }
      });
    }
  }]);
  return Formulation;
}(MixInto(UpdatableBase, typeAttributeMixin));
var _excluded = ["n", "p", "k", "humicAcid"];
var _class$9;
var NutrientAnalysis = (_class$9 = /*#__PURE__*/function (_UpdatableBase) {
  _inherits(NutrientAnalysis, _UpdatableBase);
  var _super = _createSuper(NutrientAnalysis);
  function NutrientAnalysis() {
    _classCallCheck(this, NutrientAnalysis);
    return _super.apply(this, arguments);
  }
  _createClass(NutrientAnalysis, [{
    key: "label",
    get: function get() {
      var _this = this;
      var _this$constructor$att = this.constructor.attributeDefinition,
        n = _this$constructor$att.n,
        p = _this$constructor$att.p,
        k = _this$constructor$att.k,
        humicAcid = _this$constructor$att.humicAcid,
        rest = _objectWithoutProperties(_this$constructor$att, _excluded);
      var result = "".concat([NutrientAnalysis.nutrientLabelComponent(this[n.key]), NutrientAnalysis.nutrientLabelComponent(this[p.key]), NutrientAnalysis.nutrientLabelComponent(this[k.key])].concat(Object.keys(rest).map(function (key) {
        return NutrientAnalysis.nutrientLabelComponent(_this[key], humanize(key));
      })).concat(NutrientAnalysis.nutrientLabelComponent(this[humicAcid.key], 'HA')).filter(Boolean).join('-'));
      return result;
    }
  }], [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      return _objectSpread2(_objectSpread2({}, _get(_getPrototypeOf(NutrientAnalysis), "getAttributeDefinition", this).call(this)), {}, {
        n: {
          name: 'N',
          key: 'n',
          type: 'string'
        },
        p: {
          name: 'P',
          key: 'p',
          type: 'string'
        },
        k: {
          name: 'K',
          key: 'k',
          type: 'string'
        },
        s: {
          name: 'S',
          key: 's',
          type: 'string'
        },
        ca: {
          name: 'Ca',
          key: 'ca',
          type: 'string'
        },
        mg: {
          name: 'Mg',
          key: 'mg',
          type: 'string'
        },
        al: {
          name: 'Al',
          key: 'al',
          type: 'string'
        },
        b: {
          name: 'B',
          key: 'b',
          type: 'string'
        },
        cu: {
          name: 'Cu',
          key: 'cu',
          type: 'string'
        },
        fe: {
          name: 'Fe',
          key: 'fe',
          type: 'string'
        },
        mn: {
          name: 'Mn',
          key: 'mn',
          type: 'string'
        },
        mo: {
          name: 'Mo',
          key: 'mo',
          type: 'string'
        },
        si: {
          name: 'Si',
          key: 'si',
          type: 'string'
        },
        zn: {
          name: 'Zn',
          key: 'zn',
          type: 'string'
        },
        humicAcid: {
          name: 'Humic Acid',
          key: 'humicAcid',
          jsKey: 'humicAcid',
          type: 'string'
        }
      });
    }
  }, {
    key: "nutrientLabelComponent",
    value: function nutrientLabelComponent(value) {
      var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var number = Number(value);
      if (label && number === 0) return '';
      return "".concat(truncateZeros(value || '0')).concat(label);
    }
  }]);
  return NutrientAnalysis;
}(UpdatableBase), _applyDecoratedDescriptor(_class$9.prototype, "label", [computed], Object.getOwnPropertyDescriptor(_class$9.prototype, "label"), _class$9.prototype), _class$9);
var _class$8, _class2$8, _temp$8;
var OrganicListing = (_class$8 = (_temp$8 = _class2$8 = /*#__PURE__*/function (_MixInto) {
  _inherits(OrganicListing, _MixInto);
  var _super = _createSuper(OrganicListing);
  function OrganicListing() {
    _classCallCheck(this, OrganicListing);
    return _super.apply(this, arguments);
  }
  _createClass(OrganicListing, [{
    key: "isExpired",
    get: function get() {
      if (!this.expires) return false;
      return new Date() > new Date(this.expires);
    }
  }, {
    key: "displayExpireDate",
    get: function get() {
      if (!this.expires) return '';
      var date = moment(this.momentFriendlyDate, 'YYYY-MM-DD');
      return date.format('MMMM DD, YYYY');
    }
  }, {
    key: "momentFriendlyDate",
    get: function get() {
      return new Date(this.expires).toISOString();
    }
  }], [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(OrganicListing), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: this.type
        }),
        productId: {
          name: 'Product ID',
          key: 'productId',
          type: 'string'
        },
        reference: {
          name: 'Reference',
          key: 'reference',
          type: 'string'
        },
        agency: {
          name: 'Agency',
          key: 'agency',
          type: 'string'
        },
        number: {
          name: 'Number',
          key: 'number',
          type: 'string'
        },
        expires: {
          name: 'Expires',
          key: 'expires',
          type: 'string'
        },
        certificateUrl: {
          name: 'Certificate URL',
          key: 'certificateUrl',
          type: 'string'
        }
      });
    }
  }]);
  return OrganicListing;
}(MixInto(UpdatableBase, idAttributeMixin, serialAttributeMixin, timestampAttributesMixin, typeAttributeMixin)), _defineProperty(_class2$8, "type", 'IF2::ProductOrganicListing'), _temp$8), (_applyDecoratedDescriptor(_class$8.prototype, "isExpired", [computed], Object.getOwnPropertyDescriptor(_class$8.prototype, "isExpired"), _class$8.prototype), _applyDecoratedDescriptor(_class$8.prototype, "displayExpireDate", [computed], Object.getOwnPropertyDescriptor(_class$8.prototype, "displayExpireDate"), _class$8.prototype), _applyDecoratedDescriptor(_class$8.prototype, "momentFriendlyDate", [computed], Object.getOwnPropertyDescriptor(_class$8.prototype, "momentFriendlyDate"), _class$8.prototype)), _class$8);
var OrganicProductValidation = /*#__PURE__*/function (_AbstractValidation) {
  _inherits(OrganicProductValidation, _AbstractValidation);
  var _super = _createSuper(OrganicProductValidation);
  function OrganicProductValidation() {
    _classCallCheck(this, OrganicProductValidation);
    return _super.apply(this, arguments);
  }
  _createClass(OrganicProductValidation, [{
    key: "failures",
    value: function failures(recommendation) {
      var _this = this;
      var failures = [];
      recommendation.productApplications.forEach(function (productApplication) {
        var message = _this.constructor.failureMessage(recommendation, productApplication);
        if (message) {
          failures.push(new Failure({
            key: _this.attribute,
            value: productApplication,
            fullMessage: message
          }));
        }
      });
      return failures;
    }
  }], [{
    key: "failureMessage",
    value: function failureMessage(recommendation, productApplication) {
      var _productApplication$p;
      if (recommendation !== null && recommendation !== void 0 && recommendation.organic && !((_productApplication$p = productApplication.product) !== null && _productApplication$p !== void 0 && _productApplication$p.isOrganic)) {
        return "".concat(productApplication.product.name, " cannot be used on an organic recommendation");
      }
    }
  }]);
  return OrganicProductValidation;
}(AbstractValidation);
var _class$7, _class2$7, _temp$7;
var ProductCropLabel = (_class$7 = (_temp$7 = _class2$7 = /*#__PURE__*/function (_MixInto) {
  _inherits(ProductCropLabel, _MixInto);
  var _super = _createSuper(ProductCropLabel);
  function ProductCropLabel() {
    _classCallCheck(this, ProductCropLabel);
    return _super.apply(this, arguments);
  }
  _createClass(ProductCropLabel, [{
    key: "hasMaxPerApplicationConstraint",
    get: function get() {
      return Quantity.isQuantityTruthy(this.maxPerApplication);
    }
  }, {
    key: "satisfiesMaxPerApplicationConstraint",
    value: function satisfiesMaxPerApplicationConstraint(calculation) {
      if (!this.hasMaxPerApplicationConstraint || !Quantity.isQuantityTruthy(calculation.rate)) {
        return true;
      } // same units

      if (this.maxPerApplication.isCompatible(calculation.rate)) {
        return calculation.rate.lte(this.maxPerApplication);
      } // max is perArea, rate is perVolume

      if (this.maxPerApplication.isCompatible(calculation.productPerAcre)) {
        if (!calculation.gallonsPerAcre) return true;
        return calculation.productPerAcre.lte(this.maxPerApplication);
      } // max is perVolume, rate is perArea

      if (this.maxPerApplication.isCompatible(calculation.productPerVolume)) {
        if (!calculation.gallonsPerAcre) return true;
        return calculation.productPerVolume.lte(this.maxPerApplication);
      } // In this case we likely don't have all the information for calculation
      // therefore pass validation

      return true;
    }
  }], [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(ProductCropLabel), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: this.type
        }),
        crop: {
          name: 'Crop',
          key: 'crop',
          type: 'string'
        },
        applicationMethods: {
          name: 'Application Method',
          key: 'applicationMethods',
          type: 'array'
        },
        phi: {
          name: 'PHI',
          key: 'phi',
          type: 'model',
          modelClass: Quantity,
          defaultValue: new Quantity('')
        },
        rei: {
          name: 'REI',
          key: 'rei',
          type: 'model',
          modelClass: Quantity,
          defaultValue: new Quantity('')
        },
        minSprayRate: {
          name: 'Min. Spray Rate',
          key: 'minSprayRate',
          type: 'model',
          modelClass: Quantity,
          defaultValue: new Quantity('')
        },
        maxSprayRate: {
          name: 'Max. Spray Rate',
          key: 'maxSprayRate',
          type: 'model',
          modelClass: Quantity,
          defaultValue: new Quantity('')
        },
        minTreatmentInterval: {
          name: 'Min Treatment Interval',
          key: 'minTreatmentInterval',
          type: 'model',
          modelClass: Quantity,
          defaultValue: new Quantity('')
        },
        maxApplicationsPerYear: {
          name: 'Max Applications Per Year',
          key: 'maxApplicationsPerYear',
          type: 'number'
        },
        maxPerApplication: {
          name: 'Max Per Application',
          key: 'maxPerApplication',
          type: 'model',
          modelClass: Quantity,
          defaultValue: new Quantity('')
        },
        maxPerYear: {
          name: 'Max Per Year',
          key: 'maxPerYear',
          type: 'model',
          modelClass: Quantity,
          defaultValue: new Quantity('')
        },
        productId: {
          name: 'Product ID',
          key: 'productId',
          type: 'number'
        },
        specialConditions: {
          name: 'Special Conditions',
          key: 'specialConditions',
          type: 'object'
        }
      });
    }
  }]);
  return ProductCropLabel;
}(MixInto(UpdatableBase, idAttributeMixin, serialAttributeMixin, timestampAttributesMixin, typeAttributeMixin)), _defineProperty(_class2$7, "type", 'IF2::Product::CropLabel'), _temp$7), _applyDecoratedDescriptor(_class$7.prototype, "hasMaxPerApplicationConstraint", [computed], Object.getOwnPropertyDescriptor(_class$7.prototype, "hasMaxPerApplicationConstraint"), _class$7.prototype), _class$7);
var _class$6, _class2$6, _temp$6;
var Product = (_class$6 = (_temp$6 = _class2$6 = /*#__PURE__*/function (_MixInto) {
  _inherits(Product, _MixInto);
  var _super = _createSuper(Product);
  function Product() {
    _classCallCheck(this, Product);
    return _super.apply(this, arguments);
  }
  _createClass(Product, [{
    key: "baseUnit",
    get: function get() {
      return this.formulation && this.formulation.baseUnit;
    }
  }, {
    key: "baseUnitPerArea",
    get: function get() {
      return "".concat(this.baseUnit, "/m^2");
    }
  }, {
    key: "baseUnitPerVolume",
    get: function get() {
      return "".concat(this.baseUnit, "/L");
    }
  }, {
    key: "epaExempt",
    get: function get() {
      return this.epaNumber === 'Exempt';
    }
  }, {
    key: "hasNutrientAnalysis",
    get: function get() {
      return !!this.nutrientAnalysis;
    }
  }, {
    key: "nutrientAnalysisLabel",
    get: function get() {
      return this.hasNutrientAnalysis ? this.nutrientAnalysis.label : '';
    }
  }, {
    key: "isActive",
    get: function get() {
      return !this.inactive;
    }
  }, {
    key: "rateUnitChoices",
    get: function get() {
      var _this = this;
      var choices = [];
      var unitlessNumerator = this.baseUnit === '';
      choices.push({
        group: 'Standard',
        value: "".concat(this.baseUnit, "/acre")
      });
      choices.push({
        group: 'Standard',
        value: "".concat(this.baseUnit, "/hgal"),
        displayName: "".concat(this.baseUnit, "/100 gal")
      });
      if (!unitlessNumerator) {
        var base = Qty(this.baseUnit);
        var specs = [];
        if (base.isCompatible(Qty('kg'))) {
          specs = [{
            system: 'US',
            numerators: ['oz', 'lbs', 'tons'],
            denominators: ['acre', 'hgal']
          }, {
            system: 'Metric (SI)',
            numerators: ['grams', 'kg'],
            denominators: ['hectare', 'L']
          }, {
            system: 'Hybrid (US/Metric)',
            numerators: ['grams', 'kg'],
            denominators: ['acre', 'hgal']
          }];
        } else if (base.isCompatible(Qty('L'))) {
          specs = [{
            system: 'US',
            numerators: ['floz', 'pt', 'qt', 'gal'],
            denominators: ['acre', 'hgal']
          }, {
            system: 'Metric (SI)',
            numerators: ['mL', 'L'],
            denominators: ['hectare']
          }, {
            system: 'Metric (SI)',
            numerators: ['mL'],
            denominators: ['L']
          }, {
            system: 'Hybrid (US/Metric)',
            numerators: ['mL', 'L'],
            denominators: ['acre']
          }, {
            system: 'Hybrid (US/Metric)',
            numerators: ['mL'],
            denominators: ['gal', 'hgal']
          }];
        }
        specs.forEach(function (spec) {
          var system = spec.system,
            numerators = spec.numerators,
            denominators = spec.denominators;
          denominators.forEach(function (denominator) {
            numerators.filter(function (each) {
              return each !== _this.baseUnit;
            }).forEach(function (numerator) {
              var value = "".concat(numerator, "/").concat(denominator);
              choices.push({
                group: system,
                value: value,
                displayName: value.replace('hgal', '100 gal')
              });
            });
          });
        });
      }
      return choices;
    }
  }, {
    key: "displayStateRegistration",
    get: function get() {
      var _this2 = this;
      var stateRegistration = '';
      if (this.epaExempt && this.stateRegistration && Object.keys(this.stateRegistration).length > 0) {
        stateRegistration = Object.keys(this.stateRegistration).sort().map(function (state) {
          return "".concat(state.toUpperCase(), " ").concat(_this2.stateRegistration[state]);
        }).join(', ');
      }
      return stateRegistration;
    }
  }, {
    key: "searchText",
    get: function get() {
      return "".concat(this.name, " ").concat(this.manufacturer, " ").concat(this.activeIngredients.map(function (i) {
        return i.name;
      }).join(' '), " ").concat(this.alternateNames.join(' ')).toLowerCase();
    }
  }, {
    key: "isOrganic",
    get: function get() {
      if (this.organicListings && this.organicListings.length > 0) {
        return true;
      }
      return false;
    }
  }, {
    key: "getPrimaryOrganicListing",
    value: function getPrimaryOrganicListing(priorityHash) {
      var _this3 = this;
      if (!this.isOrganic) return;
      var _this$organicListings = _slicedToArray(this.organicListings, 1),
        primaryListing = _this$organicListings[0];
      this.organicListings.forEach(function (listing) {
        if (_this3.constructor.getAgencyPriority(priorityHash, listing.agency) > _this3.constructor.getAgencyPriority(priorityHash, primaryListing.agency)) primaryListing = listing;
      });
      return primaryListing;
    }
  }, {
    key: "labelsForUseOn",
    value: function labelsForUseOn(recommendation) {
      var _this4 = this;
      if (isEmpty(recommendation.cropNames)) {
        return this.labelsMatching({
          applicationMethod: recommendation.applicationMethod
        });
      }
      return reduce(function (labels, crop) {
        return labels.concat(_this4.labelsMatching({
          crop: crop,
          applicationMethod: recommendation.applicationMethod
        }));
      }, [], recommendation.cropNames);
    }
  }, {
    key: "isLabeledForUseOn",
    value: function isLabeledForUseOn(recommendation) {
      var _this5 = this;
      if (isEmpty(recommendation.cropNames)) {
        if (!recommendation.applicationMethod) return true;
        return this.isLabeledFor({
          applicationMethod: recommendation.applicationMethod
        });
      }
      return all(function (crop) {
        return _this5.isLabeledFor({
          crop: crop,
          applicationMethod: recommendation.applicationMethod
        });
      }, recommendation.cropNames);
    }
  }, {
    key: "isForUseOn",
    value: function isForUseOn(recommendation) {
      if (recommendation.organic && !this.organic) return false;
      return this.isLabeledForUseOn(recommendation);
    }
  }, {
    key: "isLabeledFor",
    value: function isLabeledFor() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return !isEmpty(this.labelsMatching(options));
    }
  }, {
    key: "labelsMatching",
    value: function labelsMatching() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.cropLabels.filter(function (label) {
        if (options.crop && label.crop !== options.crop) {
          return false;
        }
        if (options.applicationMethod && !label.applicationMethods.includes(options.applicationMethod)) {
          return false;
        }
        return true;
      });
    }
  }], [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(Product), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: this.type
        }),
        account: {
          name: 'Account',
          key: 'account',
          type: 'model',
          modelClass: AccountWithPath,
          defaultValue: new AccountWithPath()
        },
        manufacturer: {
          name: 'Manufacturer',
          key: 'manufacturer',
          type: 'string'
        },
        epaNumber: {
          name: 'EPA Number',
          key: 'epaNumber',
          type: 'string'
        },
        signalWord: {
          name: 'Signal Word',
          key: 'signalWord',
          type: 'string'
        },
        productType: {
          name: 'Product Type',
          key: 'productType',
          type: 'string'
        },
        use: {
          name: 'Use',
          key: 'use',
          type: 'string'
        },
        formulation: {
          name: 'Formulation',
          key: 'formulation',
          type: 'model',
          modelClass: Formulation,
          defaultValue: new Formulation()
        },
        alternateNames: {
          name: 'Alternate Name',
          key: 'alternateNames',
          type: 'array'
        },
        activeIngredients: {
          name: 'Active Ingredient',
          key: 'activeIngredients',
          type: 'modelCollection',
          modelClass: ActiveIngredient
        },
        nutrientAnalysis: {
          name: 'Nutrient Analysis',
          key: 'nutrientAnalysis',
          type: 'model',
          modelClass: NutrientAnalysis
        },
        stateRegistration: {
          name: 'State Registration',
          key: 'stateRegistration',
          type: 'object'
        },
        labelUrl: {
          name: 'Label URL',
          key: 'labelUrl',
          type: 'string'
        },
        sdsUrl: {
          name: 'SDS URL',
          key: 'sdsUrl',
          type: 'string'
        },
        beeHazard: {
          name: 'Bee Hazard',
          key: 'beeHazard',
          type: 'string'
        },
        organic: {
          name: 'Organic',
          key: 'organic',
          type: 'boolean'
        },
        organicListings: {
          name: 'Organic Listing',
          key: 'organicListings',
          type: 'modelCollection',
          searchKey: 'serial',
          modelClass: OrganicListing
        },
        notes: {
          name: 'Notes',
          key: 'notes',
          type: 'string'
        },
        reviewedAt: {
          name: 'Reviewed At',
          key: 'reviewedAt',
          type: 'string'
        },
        inactive: {
          name: 'Inactive',
          key: 'inactive',
          type: 'boolean'
        },
        cropLabels: {
          name: 'Crop Labels',
          key: 'cropLabels',
          type: 'modelCollection',
          modelClass: ProductCropLabel
        },
        acheInhibitor: {
          name: 'Ache Inhibitor',
          key: 'acheInhibitor',
          type: 'boolean'
        },
        targetRatesRequired: {
          name: 'Target Rates Required',
          key: 'targetRatesRequired',
          type: 'boolean'
        },
        registrationNumber: {
          name: 'Registration Number',
          key: 'registrationNumber',
          type: 'string'
        },
        massPerVolume: {
          name: 'Weight Per Volume',
          key: 'massPerVolume',
          type: 'model',
          modelClass: Quantity
        }
      });
    }
  }, {
    key: "getAgencyPriority",
    value: function getAgencyPriority(priorityHash, agency) {
      return priorityHash[agency] || 0;
    }
  }]);
  return Product;
}(MixInto(UpdatableBase, idAttributeMixin, nameAttributeMixin, serialAttributeMixin, timestampAttributesMixin, typeAttributeMixin)), _defineProperty(_class2$6, "type", 'IF2::Product'), _defineProperty(_class2$6, "sortByName", function (product1, product2) {
  return naturalSort(product1.name.toLowerCase(), product2.name.toLowerCase());
}), _temp$6), (_applyDecoratedDescriptor(_class$6.prototype, "baseUnit", [computed], Object.getOwnPropertyDescriptor(_class$6.prototype, "baseUnit"), _class$6.prototype), _applyDecoratedDescriptor(_class$6.prototype, "baseUnitPerArea", [computed], Object.getOwnPropertyDescriptor(_class$6.prototype, "baseUnitPerArea"), _class$6.prototype), _applyDecoratedDescriptor(_class$6.prototype, "baseUnitPerVolume", [computed], Object.getOwnPropertyDescriptor(_class$6.prototype, "baseUnitPerVolume"), _class$6.prototype), _applyDecoratedDescriptor(_class$6.prototype, "epaExempt", [computed], Object.getOwnPropertyDescriptor(_class$6.prototype, "epaExempt"), _class$6.prototype), _applyDecoratedDescriptor(_class$6.prototype, "hasNutrientAnalysis", [computed], Object.getOwnPropertyDescriptor(_class$6.prototype, "hasNutrientAnalysis"), _class$6.prototype), _applyDecoratedDescriptor(_class$6.prototype, "nutrientAnalysisLabel", [computed], Object.getOwnPropertyDescriptor(_class$6.prototype, "nutrientAnalysisLabel"), _class$6.prototype), _applyDecoratedDescriptor(_class$6.prototype, "isActive", [computed], Object.getOwnPropertyDescriptor(_class$6.prototype, "isActive"), _class$6.prototype), _applyDecoratedDescriptor(_class$6.prototype, "rateUnitChoices", [computed], Object.getOwnPropertyDescriptor(_class$6.prototype, "rateUnitChoices"), _class$6.prototype), _applyDecoratedDescriptor(_class$6.prototype, "displayStateRegistration", [computed], Object.getOwnPropertyDescriptor(_class$6.prototype, "displayStateRegistration"), _class$6.prototype), _applyDecoratedDescriptor(_class$6.prototype, "searchText", [computed], Object.getOwnPropertyDescriptor(_class$6.prototype, "searchText"), _class$6.prototype), _applyDecoratedDescriptor(_class$6.prototype, "isOrganic", [computed], Object.getOwnPropertyDescriptor(_class$6.prototype, "isOrganic"), _class$6.prototype)), _class$6);
var ProductReference = /*#__PURE__*/function (_MixInto) {
  _inherits(ProductReference, _MixInto);
  var _super = _createSuper(ProductReference);
  function ProductReference() {
    _classCallCheck(this, ProductReference);
    return _super.apply(this, arguments);
  }
  _createClass(ProductReference, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(ProductReference), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: 'IF2::Product'
        })
      });
    }
  }, {
    key: "fromProduct",
    value: function fromProduct(product) {
      return new ProductReference({
        id: product.id,
        serial: product.serial,
        name: product.name,
        type: product.type
      });
    }
  }, {
    key: "fromModel",
    value: function fromModel(model) {
      return this.fromProduct(model);
    }
  }]);
  return ProductReference;
}(MixInto(ModelReference, serialAttributeMixin));
var ProductApplicationBase = /*#__PURE__*/function (_MixInto) {
  _inherits(ProductApplicationBase, _MixInto);
  var _super = _createSuper(ProductApplicationBase);
  function ProductApplicationBase() {
    _classCallCheck(this, ProductApplicationBase);
    return _super.apply(this, arguments);
  }
  _createClass(ProductApplicationBase, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(ProductApplicationBase), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        id: _objectSpread2(_objectSpread2({}, inherited.id), {}, {
          defaultValue: v4()
        }),
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: this.type
        }),
        product: {
          name: 'Product',
          key: 'product',
          type: 'model',
          modelClass: Product,
          defaultValue: new Product()
        },
        rate: {
          name: 'Rate',
          key: 'rate',
          type: 'model',
          modelClass: Quantity
        },
        target: {
          name: 'Target',
          key: 'target',
          type: 'string'
        },
        position: {
          name: 'Position',
          key: 'position',
          type: 'number'
        }
      });
    }
  }, {
    key: "from",
    value: function from(props) {
      return new this(props);
    }
  }]);
  return ProductApplicationBase;
}(MixInto(UpdatableBase, idAttributeMixin, serialAttributeMixin, typeAttributeMixin));
_defineProperty(ProductApplicationBase, "type", 'IF2::ProductApplicationBase');
var _class$5, _class2$5, _temp$5;
var RecommendationProductApplication = (_class$5 = (_temp$5 = _class2$5 = /*#__PURE__*/function (_MixInto) {
  _inherits(RecommendationProductApplication, _MixInto);
  var _super = _createSuper(RecommendationProductApplication);
  function RecommendationProductApplication() {
    var _this;
    _classCallCheck(this, RecommendationProductApplication);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "validations", [new Presence('product'), new QuantityComparison('rate', {
      gt: 0
    })]);
    return _this;
  }
  _createClass(RecommendationProductApplication, [{
    key: "name",
    get: function get() {
      var _this$product;
      return ((_this$product = this.product) === null || _this$product === void 0 ? void 0 : _this$product.name) || '';
    }
  }, {
    key: "cropLabels",
    get: function get() {
      var _this2 = this;
      var cropLabels = this.product.cropLabels.filter(function (cl) {
        return _this2.cropNames.includes(cl.crop);
      });
      if (this.applicationMethod) {
        return cropLabels.filter(function (cl) {
          return cl.applicationMethods.length < 1 || cl.applicationMethods.includes(_this2.applicationMethod);
        });
      }
      return cropLabels;
    }
  }, {
    key: "phi",
    get: function get() {
      return this.cropLabels.reduce(function (phi, label) {
        if (!label.phi || !label.phi.toJS() || phi && phi.toJS() && phi.gte(label.phi)) {
          return phi;
        }
        return label.phi;
      }, new Quantity(''));
    }
  }, {
    key: "rei",
    get: function get() {
      return this.cropLabels.reduce(function (rei, label) {
        if (!label.rei || !label.rei.toJS() || rei && rei.toJS() && rei.gte(label.rei)) {
          return rei;
        }
        return label.rei;
      }, new Quantity(''));
    }
  }, {
    key: "setProduct",
    value: function setProduct(product) {
      var _this$rate;
      var note = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.update({
        product: product.toJS()
      });
      if (!product) {
        return;
      }
      if ((_this$rate = this.rate) !== null && _this$rate !== void 0 && _this$rate.units && !Quantity.isCompatible(this.rate.units.split('/')[0], product.baseUnit)) {
        this.rate.units = '';
      }
      if (note) {
        this.notes = note.text;
      }
    }
  }, {
    key: "isOrganic",
    get: function get() {
      var _this$product2;
      return (_this$product2 = this.product) === null || _this$product2 === void 0 ? void 0 : _this$product2.isOrganic;
    }
  }], [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(RecommendationProductApplication), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: this.type
        }),
        applicationMethod: {
          name: 'Application Method',
          key: 'applicationMethod',
          type: 'string'
        },
        cropNames: {
          name: 'Crop Names',
          key: 'cropNames',
          type: 'array'
        },
        notes: {
          name: 'Notes',
          key: 'notes',
          type: 'string'
        }
      });
    }
  }]);
  return RecommendationProductApplication;
}(MixInto(ProductApplicationBase, timestampAttributesMixin, validatableMixin)), _defineProperty(_class2$5, "type", 'IF2::Recommendation::ProductApplication'), _temp$5), (_applyDecoratedDescriptor(_class$5.prototype, "name", [computed], Object.getOwnPropertyDescriptor(_class$5.prototype, "name"), _class$5.prototype), _applyDecoratedDescriptor(_class$5.prototype, "cropLabels", [computed], Object.getOwnPropertyDescriptor(_class$5.prototype, "cropLabels"), _class$5.prototype), _applyDecoratedDescriptor(_class$5.prototype, "phi", [computed], Object.getOwnPropertyDescriptor(_class$5.prototype, "phi"), _class$5.prototype), _applyDecoratedDescriptor(_class$5.prototype, "rei", [computed], Object.getOwnPropertyDescriptor(_class$5.prototype, "rei"), _class$5.prototype), _applyDecoratedDescriptor(_class$5.prototype, "setProduct", [action], Object.getOwnPropertyDescriptor(_class$5.prototype, "setProduct"), _class$5.prototype), _applyDecoratedDescriptor(_class$5.prototype, "isOrganic", [computed], Object.getOwnPropertyDescriptor(_class$5.prototype, "isOrganic"), _class$5.prototype)), _class$5);
var _class$4, _class2$4, _temp$4;
var ProductApplicationCalculation = (_class$4 = (_temp$4 = _class2$4 = /*#__PURE__*/function (_RecommendationProduc) {
  _inherits(ProductApplicationCalculation, _RecommendationProduc);
  var _super = _createSuper(ProductApplicationCalculation);
  function ProductApplicationCalculation() {
    var _this;
    _classCallCheck(this, ProductApplicationCalculation);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "unitLimit", 0.75);
    _defineProperty(_assertThisInitialized(_this), "isMetric", function (unit) {
      return ['mL', 'L', 'grams', 'g', 'kg'].includes(unit);
    });
    _defineProperty(_assertThisInitialized(_this), "toLargeUnit", function (quantity) {
      var isMetric = _this.isMetric(quantity.units);
      var isDry = quantity.isCompatible('lbs');
      if (isMetric && isDry) {
        return quantity.to('kg');
      }
      if (isMetric && !isDry) {
        return quantity.to('L');
      }
      if (!isMetric && isDry) {
        return quantity.to('lbs');
      }
      if (!isMetric && !isDry && quantity.isCompatible('gal')) {
        return quantity.to('gal');
      }
      return quantity;
    });
    _defineProperty(_assertThisInitialized(_this), "toSmallUnit", function (quantity) {
      var unit = quantity.units;
      var smallUnit;
      switch (unit) {
        case 'kg':
          smallUnit = 'grams';
          break;
        case 'L':
          smallUnit = 'mL';
          break;
        case 'lbs':
          smallUnit = 'oz';
          break;
        case 'gal':
          smallUnit = 'floz';
          break;
        default:
          smallUnit = quantity.units;
      }
      return quantity.to(smallUnit);
    });
    return _this;
  }
  _createClass(ProductApplicationCalculation, [{
    key: "totalAcres",
    get: function get() {
      if (this.totalAcresScalar === 0 || this.totalAcresScalar) {
        return new Quantity("".concat(this.totalAcresScalar, " acre"));
      }
      return new Quantity('');
    }
  }, {
    key: "productTotalQuantity",
    get: function get() {
      var _this$rate, _this$rate2, _this$totalAcres, _this$totalAcres2;
      if (((_this$rate = this.rate) === null || _this$rate === void 0 ? void 0 : _this$rate.scalar) !== 0 && !((_this$rate2 = this.rate) !== null && _this$rate2 !== void 0 && _this$rate2.scalar) || ((_this$totalAcres = this.totalAcres) === null || _this$totalAcres === void 0 ? void 0 : _this$totalAcres.scalar) !== 0 && !((_this$totalAcres2 = this.totalAcres) !== null && _this$totalAcres2 !== void 0 && _this$totalAcres2.scalar)) {
        return new Quantity('');
      }
      var quantity;
      if (this.isPerArea) {
        var _this$rate3;
        quantity = (_this$rate3 = this.rate) === null || _this$rate3 === void 0 ? void 0 : _this$rate3.mul(this.totalAcres);
      }
      if (this.isPerVolume) {
        var _this$rate4;
        quantity = (_this$rate4 = this.rate) === null || _this$rate4 === void 0 ? void 0 : _this$rate4.mul(this.gallonsPerAcre).mul(this.totalAcres);
      }
      if (!quantity) {
        return new Quantity('');
      }
      if (quantity.scalar !== 0 && quantity.units) {
        quantity = this.toLargeUnit(quantity);
        if (quantity.scalar < this.unitLimit) {
          quantity = this.toSmallUnit(quantity);
        }
      }
      quantity.updateScalar(quantity.scalar * this.coverage);
      return quantity;
    }
  }, {
    key: "productPerAcre",
    get: function get() {
      if (this.isPerVolume) {
        return this.rate.mul(this.gallonsPerAcre);
      }
      return this.rate;
    }
  }, {
    key: "productPerVolume",
    get: function get() {
      var gallonsPerAcre = new Quantity(this.gallonsPerAcre);
      if (!Quantity.isQuantityTruthy(gallonsPerAcre)) {
        return new Quantity();
      }
      if (this.isPerArea) {
        return this.rate.div(gallonsPerAcre);
      }
      return this.rate;
    }
  }, {
    key: "productTankAmount",
    get: function get() {
      var _this$rate5, _this$rate6, _this$tankSize, _this$tankSize2, _this$rate7, _this$rate8, _this$rate10;
      if (((_this$rate5 = this.rate) === null || _this$rate5 === void 0 ? void 0 : _this$rate5.scalar) !== 0 && !((_this$rate6 = this.rate) !== null && _this$rate6 !== void 0 && _this$rate6.scalar) || ((_this$tankSize = this.tankSize) === null || _this$tankSize === void 0 ? void 0 : _this$tankSize.scalar) !== 0 && !((_this$tankSize2 = this.tankSize) !== null && _this$tankSize2 !== void 0 && _this$tankSize2.scalar) || ((_this$rate7 = this.rate) === null || _this$rate7 === void 0 ? void 0 : _this$rate7.units) === '1/acre' || ((_this$rate8 = this.rate) === null || _this$rate8 === void 0 ? void 0 : _this$rate8.units) === '1/hgal') {
        return new Quantity('');
      }
      var quantity;
      if (this.isPerArea) {
        var _this$rate9, _this$rate9$div;
        if (Quantity.isZero(this.gallonsPerAcre)) return new Quantity('');
        quantity = (_this$rate9 = this.rate) === null || _this$rate9 === void 0 ? void 0 : (_this$rate9$div = _this$rate9.div(this.gallonsPerAcre)) === null || _this$rate9$div === void 0 ? void 0 : _this$rate9$div.mul(this.tankSize);
      }
      if (this.isPerVolume) {
        quantity = this.rate.mul(this.tankSize);
      }
      if (!quantity) {
        return new Quantity('');
      }
      if (quantity.isCompatible((_this$rate10 = this.rate) === null || _this$rate10 === void 0 ? void 0 : _this$rate10.numeratorUnits)) {
        quantity = quantity.to(this.rate.numeratorUnits);
      }
      return quantity;
    }
  }, {
    key: "isPerArea",
    get: function get() {
      var _this$rate11, _this$product;
      return (_this$rate11 = this.rate) === null || _this$rate11 === void 0 ? void 0 : _this$rate11.isCompatible(Quantity.toQty((_this$product = this.product) === null || _this$product === void 0 ? void 0 : _this$product.baseUnitPerArea));
    }
  }, {
    key: "isPerVolume",
    get: function get() {
      var _this$rate12, _this$product2;
      return (_this$rate12 = this.rate) === null || _this$rate12 === void 0 ? void 0 : _this$rate12.isCompatible(Quantity.toQty((_this$product2 = this.product) === null || _this$product2 === void 0 ? void 0 : _this$product2.baseUnitPerVolume));
    }
  }], [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      return _objectSpread2(_objectSpread2({}, _get(_getPrototypeOf(ProductApplicationCalculation), "getAttributeDefinition", this).call(this)), {}, {
        totalAcresScalar: {
          name: 'Total Acres',
          key: 'totalAcresScalar',
          type: 'number'
        },
        gallonsPerAcre: {
          name: 'Gallons Per Acre',
          key: 'gallonsPerAcre',
          type: 'string'
        },
        tankSize: {
          name: 'Tank Size',
          key: 'tankSize',
          type: 'model',
          modelClass: Quantity,
          defaultValue: new Quantity('')
        },
        coverage: {
          name: 'Coverage',
          key: 'coverage',
          type: 'number',
          defaultValue: 1
        }
      });
    }
  }]);
  return ProductApplicationCalculation;
}(RecommendationProductApplication), _defineProperty(_class2$4, "type", 'IF2::Recommendation::ProductApplicationCalculation'), _temp$4), (_applyDecoratedDescriptor(_class$4.prototype, "totalAcres", [computed], Object.getOwnPropertyDescriptor(_class$4.prototype, "totalAcres"), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, "productTotalQuantity", [computed], Object.getOwnPropertyDescriptor(_class$4.prototype, "productTotalQuantity"), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, "productPerAcre", [computed], Object.getOwnPropertyDescriptor(_class$4.prototype, "productPerAcre"), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, "productPerVolume", [computed], Object.getOwnPropertyDescriptor(_class$4.prototype, "productPerVolume"), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, "productTankAmount", [computed], Object.getOwnPropertyDescriptor(_class$4.prototype, "productTankAmount"), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, "isPerArea", [computed], Object.getOwnPropertyDescriptor(_class$4.prototype, "isPerArea"), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, "isPerVolume", [computed], Object.getOwnPropertyDescriptor(_class$4.prototype, "isPerVolume"), _class$4.prototype)), _class$4);
var ProductLabelValidation = /*#__PURE__*/function (_AbstractValidation) {
  _inherits(ProductLabelValidation, _AbstractValidation);
  var _super = _createSuper(ProductLabelValidation);
  function ProductLabelValidation() {
    _classCallCheck(this, ProductLabelValidation);
    return _super.apply(this, arguments);
  }
  _createClass(ProductLabelValidation, [{
    key: "failures",
    value: function failures(recommendation) {
      var failures = [];
      failures = failures.concat(this.cropAndMethodFailures(recommendation));
      failures = failures.concat(this.maxPerApplicationFailures(recommendation));
      failures = failures.concat(this.minSprayRateFailures(recommendation));
      failures = failures.concat(this.maxSprayRateFailures(recommendation));
      return failures;
    }
  }, {
    key: "cropAndMethodFailures",
    value: function cropAndMethodFailures(recommendation) {
      var _this = this;
      var failures = [];
      recommendation.productApplications.forEach(function (productApplication) {
        var message = _this.constructor.cropAndMethodFailure(recommendation, productApplication);
        if (message) {
          failures.push(new Failure({
            key: _this.attribute,
            value: productApplication,
            fullMessage: message
          }));
        }
      });
      return failures;
    }
  }, {
    key: "maxPerApplicationFailures",
    value: function maxPerApplicationFailures(recommendation) {
      var _this2 = this;
      var failures = [];
      recommendation.productApplications.forEach(function (productApplication) {
        var message = _this2.constructor.maxPerApplicationFailure(recommendation, productApplication);
        if (message) {
          failures.push(new Failure({
            key: _this2.attribute,
            value: productApplication,
            fullMessage: message
          }));
        }
      });
      return failures;
    }
  }, {
    key: "minSprayRateFailures",
    value: function minSprayRateFailures(recommendation) {
      var _this3 = this;
      var failures = [];
      recommendation.productApplications.forEach(function (productApplication) {
        var message = _this3.constructor.minSprayRateFailure(recommendation, productApplication);
        if (message) {
          failures.push(new Failure({
            key: _this3.attribute,
            value: productApplication,
            fullMessage: message
          }));
        }
      });
      return failures;
    }
  }, {
    key: "maxSprayRateFailures",
    value: function maxSprayRateFailures(recommendation) {
      var _this4 = this;
      var failures = [];
      recommendation.productApplications.forEach(function (productApplication) {
        var message = _this4.constructor.maxSprayRateFailure(recommendation, productApplication);
        if (message) {
          failures.push(new Failure({
            key: _this4.attribute,
            value: productApplication,
            fullMessage: message
          }));
        }
      });
      return failures;
    }
  }], [{
    key: "maxPerApplicationFailure",
    value: function maxPerApplicationFailure(recommendation, productApplication) {
      var calculation = recommendation.newCalculationFor(productApplication);
      if (!productApplication.product || typeof productApplication.product.labelsForUseOn !== 'function') return;
      var relevantLabels = productApplication.product.labelsForUseOn(recommendation);
      if (!productApplication.rate.scalar || !productApplication.rate.units) {
        return;
      }
      var failingLabels = relevantLabels.filter(function (label) {
        return !label.satisfiesMaxPerApplicationConstraint(calculation);
      });
      if (!isEmpty(failingLabels)) {
        return "".concat(calculation.rate.displayValue, " exceeds the labeled max application rate for ").concat(productApplication.product.name, ": ").concat(listString(failingLabels.map(function (l) {
          return [l.crop, l.maxPerApplication.displayValue].join(' -> ');
        })));
      }
    }
  }, {
    key: "cropAndMethodFailure",
    value: function cropAndMethodFailure(recommendation, productApplication) {
      if (productApplication.product && typeof productApplication.product.isLabeledForUseOn === 'function' && !productApplication.product.isLabeledForUseOn(recommendation)) {
        return "".concat(productApplication.product.name, " is not labeled for the given crops and application method");
      }
    }
  }, {
    key: "minSprayRateFailure",
    value: function minSprayRateFailure(recommendation, productApplication) {
      var _productApplication$p;
      var relevantLabels = ((_productApplication$p = productApplication.product) === null || _productApplication$p === void 0 ? void 0 : _productApplication$p.labelsForUseOn(recommendation)) || [];
      if (Quantity.isQuantityTruthy(recommendation.targetRate) && relevantLabels.some(function (r) {
        return Quantity.isQuantityTruthy(r.minSprayRate) && recommendation.targetRate.lt(r.minSprayRate);
      })) {
        return "".concat(recommendation.targetRate.displayValue, " is less than the minimimum required spray rate for ").concat(productApplication.product.name);
      }
    }
  }, {
    key: "maxSprayRateFailure",
    value: function maxSprayRateFailure(recommendation, productApplication) {
      var _productApplication$p2;
      var relevantLabels = ((_productApplication$p2 = productApplication.product) === null || _productApplication$p2 === void 0 ? void 0 : _productApplication$p2.labelsForUseOn(recommendation)) || [];
      if (Quantity.isQuantityTruthy(recommendation.targetRate) && relevantLabels.some(function (r) {
        return Quantity.isQuantityTruthy(r.maxSprayRate) && recommendation.targetRate.gt(r.maxSprayRate);
      })) {
        return "".concat(recommendation.targetRate.displayValue, " is greater than the maximum required spray rate for ").concat(productApplication.product.name);
      }
    }
  }]);
  return ProductLabelValidation;
}(AbstractValidation);
var UserReference = /*#__PURE__*/function (_MixInto) {
  _inherits(UserReference, _MixInto);
  var _super = _createSuper(UserReference);
  function UserReference() {
    _classCallCheck(this, UserReference);
    return _super.apply(this, arguments);
  }
  _createClass(UserReference, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(UserReference), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: 'IF2::User'
        }),
        licenses: {
          key: 'licenses',
          type: 'array'
        }
      });
    }
  }, {
    key: "fromUser",
    value: function fromUser(user) {
      return new UserReference({
        id: user.id,
        serial: user.serial,
        type: user.type,
        name: user.name,
        licenses: user.licenses
      });
    }
  }, {
    key: "fromModel",
    value: function fromModel(model) {
      return this.fromUser(model);
    }
  }]);
  return UserReference;
}(MixInto(ModelReference, serialAttributeMixin));
var ProductRecommendationNote = /*#__PURE__*/function (_MixInto) {
  _inherits(ProductRecommendationNote, _MixInto);
  var _super = _createSuper(ProductRecommendationNote);
  function ProductRecommendationNote() {
    _classCallCheck(this, ProductRecommendationNote);
    return _super.apply(this, arguments);
  }
  _createClass(ProductRecommendationNote, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(ProductRecommendationNote), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: this.type
        }),
        product: {
          name: 'Product',
          key: 'product',
          type: 'model',
          modelClass: ProductReference,
          defaultValue: new ProductReference()
        },
        text: {
          name: 'Text',
          key: 'text',
          type: 'string'
        },
        title: {
          name: 'Title',
          key: 'title',
          type: 'string'
        },
        user: {
          name: 'User',
          key: 'user',
          type: 'model',
          modelClass: UserReference,
          defaultValue: new UserReference()
        }
      });
    }
  }]);
  return ProductRecommendationNote;
}(MixInto(UpdatableBase, idAttributeMixin, typeAttributeMixin, editableMixin));
_defineProperty(ProductRecommendationNote, "type", 'IF2::Product::RecommendationNote');
var RecommendationReference = /*#__PURE__*/function (_ModelReference) {
  _inherits(RecommendationReference, _ModelReference);
  var _super = _createSuper(RecommendationReference);
  function RecommendationReference() {
    _classCallCheck(this, RecommendationReference);
    return _super.apply(this, arguments);
  }
  _createClass(RecommendationReference, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(RecommendationReference), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: 'IF2::Recommendation'
        }),
        date: {
          name: 'Date',
          key: 'date',
          type: 'string'
        },
        accountId: {
          name: 'Account Id',
          key: 'accountId',
          type: 'string'
        },
        status: {
          name: 'Status',
          key: 'status',
          type: 'string'
        },
        accounts: {
          key: 'accounts',
          type: 'modelCollection',
          modelClass: AccountReference
        },
        writtenById: {
          name: 'Written By Id',
          key: 'writtenById',
          type: 'string'
        }
      });
    }
  }, {
    key: "isRecommendationReference",
    value: function isRecommendationReference(maybeRef) {
      return maybeRef instanceof RecommendationReference;
    }
  }, {
    key: "fromRecommendation",
    value: function fromRecommendation(recommendation) {
      return new this({
        id: recommendation.id,
        type: recommendation.type,
        name: recommendation.title,
        date: recommendation.date,
        account_id: recommendation.account.id,
        status: recommendation.status,
        accounts: recommendation.accounts,
        written_by_id: recommendation.writtenBy.id
      });
    }
  }, {
    key: "fromModel",
    value: function fromModel(model) {
      return this.fromRecommendation(model);
    }
  }]);
  return RecommendationReference;
}(ModelReference);
var NumericComparison = /*#__PURE__*/function (_AbstractValidation) {
  _inherits(NumericComparison, _AbstractValidation);
  var _super = _createSuper(NumericComparison);
  function NumericComparison() {
    _classCallCheck(this, NumericComparison);
    return _super.apply(this, arguments);
  }
  _createClass(NumericComparison, [{
    key: "failureDescription",
    value: function failureDescription(model) {
      var value = this.value(model);
      if (this.options.optional && !value) return null;
      if (this.fails('gt', value)) return "must be greater than ".concat(this.options.gt);
      if (this.fails('gte', value)) return "must be greater than or equal to ".concat(this.options.gte);
      if (this.fails('lt', value)) return "must be less than ".concat(this.options.lt);
      if (this.fails('lte', value)) return "must be less than or equal to ".concat(this.options.lte);
      return null;
    }
  }, {
    key: "failure",
    value: function failure(model) {
      var description = this.failureDescription(model);
      if (description) {
        var failure = Failure.newFrom(this, model);
        failure.description = this.options.description || description;
        return failure;
      }
    }
  }, {
    key: "fails",
    value: function fails(comparison, value) {
      if (!value) return true;
      var compareWith = this.options[comparison];
      if (compareWith === undefined || compareWith === null) return false;
      if (comparison === 'gt') return !(value > compareWith);
      if (comparison === 'gte') return !(value >= compareWith);
      if (comparison === 'lt') return !(value < compareWith);
      if (comparison === 'lte') return !(value <= compareWith);
    }
  }]);
  return NumericComparison;
}(AbstractValidation);
var ModelCollectionValidation = /*#__PURE__*/function (_AbstractValidation) {
  _inherits(ModelCollectionValidation, _AbstractValidation);
  var _super = _createSuper(ModelCollectionValidation);
  function ModelCollectionValidation() {
    _classCallCheck(this, ModelCollectionValidation);
    return _super.apply(this, arguments);
  }
  _createClass(ModelCollectionValidation, [{
    key: "failures",
    value: function failures(model) {
      var _this = this;
      var collection = this.value(model);
      if (!Array.isArray(collection)) return [];
      return collection.reduce(function (all, curr) {
        if (!_this.constructor.isValidatable(curr)) return all;
        return all.concat(curr.failures().map(function (failure) {
          return _this.adopt(failure);
        }));
      }, []);
    }
  }]);
  return ModelCollectionValidation;
}(AbstractValidation);
var applicationMethodAttributeMixin = function applicationMethodAttributeMixin(Base) {
  var _class, _temp;
  return _temp = _class = /*#__PURE__*/function (_Base) {
    _inherits(_class, _Base);
    var _super = _createSuper(_class);
    function _class() {
      _classCallCheck(this, _class);
      return _super.apply(this, arguments);
    }
    _createClass(_class, null, [{
      key: "getAttributeDefinition",
      value: function getAttributeDefinition() {
        return _objectSpread2(_objectSpread2({}, _get(_getPrototypeOf(_class), "getAttributeDefinition", this).call(this)), {}, {
          applicationMethod: {
            name: 'Application Method',
            key: 'applicationMethod',
            type: 'string'
          }
        });
      }
    }, {
      key: "requiresTankSize",
      value: function requiresTankSize(method) {
        var methodInfo = find$1(propEq('text', method))(this.applicationMethods);
        return Boolean(methodInfo === null || methodInfo === void 0 ? void 0 : methodInfo.tankSize);
      }
    }, {
      key: "requiresRate",
      value: function requiresRate(method) {
        var methodInfo = find$1(propEq('text', method))(this.applicationMethods);
        return Boolean(methodInfo === null || methodInfo === void 0 ? void 0 : methodInfo.requiresRate);
      }
    }, {
      key: "requiresSpreader",
      value: function requiresSpreader(method) {
        return Boolean(method.match(/spread/i));
      }
    }, {
      key: "requiresSprayer",
      value: function requiresSprayer(method) {
        return this.requiresRate(method);
      }
    }]);
    return _class;
  }(Base), _defineProperty(_class, "applicationMethods", [{
    text: 'Aerial',
    coverage: false,
    tankSize: true,
    requiresRate: true
  }, {
    text: 'Airblast',
    coverage: true,
    tankSize: true,
    requiresRate: true
  }, {
    text: 'Broadcast Spray',
    coverage: false,
    tankSize: true,
    requiresRate: true
  }, {
    text: 'Broadcast Spread',
    coverage: false,
    tankSize: false
  }, {
    text: 'Hand Applied',
    coverage: true,
    tankSize: false
  }, {
    text: 'Injection',
    coverage: false,
    tankSize: false
  }, {
    text: 'Banded Spray',
    coverage: true,
    tankSize: true,
    requiresRate: true
  }, {
    text: 'Subsurface Shank',
    coverage: false,
    tankSize: false
  }]), _temp;
};
var Reject = /*#__PURE__*/function (_UpdatableBase) {
  _inherits(Reject, _UpdatableBase);
  var _super = _createSuper(Reject);
  function Reject() {
    _classCallCheck(this, Reject);
    return _super.apply(this, arguments);
  }
  _createClass(Reject, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      return _objectSpread2(_objectSpread2({}, _get(_getPrototypeOf(Reject), "getAttributeDefinition", this).call(this)), {}, {
        by: {
          name: 'By',
          key: 'by',
          type: 'model',
          modelClass: UserReference,
          defaultValue: new UserReference()
        },
        reason: {
          name: 'Reason',
          key: 'reason',
          type: 'string'
        },
        at: {
          name: 'At',
          key: 'at',
          type: 'string'
        }
      });
    }
  }, {
    key: "isReject",
    value: function isReject(maybeReject) {
      return maybeReject instanceof Reject;
    }
  }]);
  return Reject;
}(UpdatableBase);
var _class$3, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _class2$3, _temp$3;
var Recommendation = (_class$3 = (_temp$3 = _class2$3 = /*#__PURE__*/function (_MixInto) {
  _inherits(Recommendation, _MixInto);
  var _super = _createSuper(Recommendation);
  function Recommendation() {
    var _this;
    _classCallCheck(this, Recommendation);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "validations", [new Presence('documentNumber', {
      attributeLabel: 'Document Number',
      fullMessage: 'Document number has not yet been assigned. The recommendation must have synced with the server before a number can be assigned'
    }), new Presence('date'), new Presence('applicationMethod'), new Presence('targetRate', {
      onlyIf: function onlyIf() {
        return _this.constructor.requiresRate(_this.applicationMethod);
      }
    }), new OrganicProductValidation('productApplications'), new ProductLabelValidation('productApplications'), new NumericComparison('coverage', {
      gt: 0,
      lte: 1,
      description: 'must be > 0 and <= 100'
    }), new ModelCollectionValidation('productApplications')]);
    _initializerDefineProperty(_assertThisInitialized(_this), "void", _descriptor, _assertThisInitialized(_this));
    _defineProperty(_assertThisInitialized(_this), "findProductApplication", function (id) {
      return _this.productApplications.find(function (pa) {
        return pa.id === id;
      });
    });
    _initializerDefineProperty(_assertThisInitialized(_this), "pushProductApplication", _descriptor2, _assertThisInitialized(_this));
    _initializerDefineProperty(_assertThisInitialized(_this), "removeProductApplication", _descriptor3, _assertThisInitialized(_this));
    _initializerDefineProperty(_assertThisInitialized(_this), "moveProductApplication", _descriptor4, _assertThisInitialized(_this));
    _initializerDefineProperty(_assertThisInitialized(_this), "addField", _descriptor5, _assertThisInitialized(_this));
    _initializerDefineProperty(_assertThisInitialized(_this), "removeField", _descriptor6, _assertThisInitialized(_this));
    return _this;
  }
  _createClass(Recommendation, [{
    key: "associatedAccountIds",
    get: function get() {
      var _this$account;
      return uniq([].concat(((_this$account = this.account) === null || _this$account === void 0 ? void 0 : _this$account.id) || []).concat((this.accounts || []).map(function (a) {
        return a.id;
      })));
    }
  }, {
    key: "totalAcres",
    get: function get() {
      return this.fields.reduce(function (acc, field) {
        var _acre;
        var acre;
        if (field !== null && field !== void 0 && field.area.isCompatible('acre')) {
          acre = field === null || field === void 0 ? void 0 : field.area.to('acre');
        }
        return acc + (((_acre = acre) === null || _acre === void 0 ? void 0 : _acre.scalar) || 0);
      }, 0);
    }
  }, {
    key: "title",
    get: function get() {
      return this.name || this.dateTitle;
    }
  }, {
    key: "dateTitle",
    get: function get() {
      return moment(this.date, ['M/D/YYYY', 'YYYY-MM-DD']).format('M/D/YYYY') || '';
    }
  }, {
    key: "updatedAtTitle",
    get: function get() {
      return moment(this.updatedAt, ['M/D/YYYY', 'YYYY-MM-DD']).format('M/D/YYYY') || '';
    }
  }, {
    key: "fieldAccounts",
    get: function get() {
      return uniqBy('id', this.fields.map(function (each) {
        return each.account;
      }));
    }
  }, {
    key: "maxPhi",
    get: function get() {
      return Quantity.max.apply(Quantity, _toConsumableArray(this.productApplications.map(function (pa) {
        return pa.phi;
      })));
    }
  }, {
    key: "maxRei",
    get: function get() {
      return Quantity.max.apply(Quantity, _toConsumableArray(this.productApplications.map(function (pa) {
        return pa.rei;
      })));
    }
  }, {
    key: "isComplete",
    get: function get() {
      return this.status === 'complete';
    }
  }, {
    key: "isDraft",
    get: function get() {
      return !this.status || this.status === 'draft';
    }
  }, {
    key: "isProvisional",
    get: function get() {
      return !this.documentNumber;
    }
  }, {
    key: "isVoid",
    get: function get() {
      return this.status === 'void' || this.status === 'replaced';
    }
  }, {
    key: "isReplaced",
    get: function get() {
      return this.status === 'replaced';
    }
  }, {
    key: "isRejected",
    get: function get() {
      return Reject.isReject(this.rejected);
    }
  }, {
    key: "isPendingApproval",
    get: function get() {
      return this.status === 'pending-approval';
    }
  }, {
    key: "defaultFilename",
    get: function get() {
      var filename = "".concat(this.defaultFilenameBase, ".pdf");
      return sanitize(filename, {
        replacement: '_'
      });
    }
  }, {
    key: "defaultFilenameBase",
    get: function get() {
      var _this$account2;
      return [].concat(this.formatDate('YYYY-MM-DD') || []).concat(((_this$account2 = this.account) === null || _this$account2 === void 0 ? void 0 : _this$account2.name) || []).concat(this.name ? "- ".concat(this.name) : []).concat(this.isDraft ? '[Draft]' : []).concat("(".concat(this.documentNumber || 'provisional', ")")).join(' ');
    }
  }, {
    key: "defaultFilenamePendingApproval",
    get: function get() {
      var filename = "".concat(this.defaultFilenameBase, " (pending approval).pdf");
      return sanitize(filename, {
        replacement: '_'
      });
    }
  }, {
    key: "hasProductNotes",
    get: function get() {
      var withNotes = this.productApplications.filter(function (pa) {
        return pa.notes.trim().length > 0;
      });
      return withNotes.length > 0;
    }
  }, {
    key: "productNotes",
    get: function get() {
      return this.productApplications.map(function (pa) {
        return pa.notes;
      }).join('\n');
    }
  }, {
    key: "productApplicationCalculations",
    get: function get() {
      var _this2 = this;
      return (this.productApplications || []).map(function (pa) {
        return _this2.newCalculationFor(pa);
      });
    }
  }, {
    key: "currentCropNamesFromFields",
    get: function get() {
      return uniq((this.fields || []).map(function (f) {
        return f.cropName;
      }));
    }
  }, {
    key: "coveragePercentString",
    get: function get() {
      return decimalToPercentString(this.coverage);
    }
  }, {
    key: "hasErrors",
    get: function get() {
      return this.failures().length > 0;
    }
  }, {
    key: "newCalculationFor",
    value: function newCalculationFor(productApplication) {
      var _this$tankSize, _this$targetRate;
      return new ProductApplicationCalculation(_objectSpread2(_objectSpread2({}, productApplication.toJS()), {}, {
        tankSize: ((_this$tankSize = this.tankSize) === null || _this$tankSize === void 0 ? void 0 : _this$tankSize.toJS()) || '',
        totalAcresScalar: this.totalAcres,
        gallonsPerAcre: ((_this$targetRate = this.targetRate) === null || _this$targetRate === void 0 ? void 0 : _this$targetRate.displayValue) || '',
        coverage: this.coverage
      }));
    }
  }, {
    key: "fieldsForAccount",
    value: function fieldsForAccount(account) {
      return this.fields.filter(function (each) {
        return each.account.id === account.id;
      });
    }
  }, {
    key: "formatDate",
    value: function formatDate(format) {
      return moment(this.date, ['M/D/YYYY', 'YYYY-MM-DD']).format(format);
    }
  }], [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(Recommendation), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: this.type
        }),
        rev: {
          key: 'rev',
          jsKey: '_rev',
          type: 'string'
        },
        date: {
          name: 'Date',
          key: 'date',
          type: 'string'
        },
        timing: {
          name: 'Timing',
          key: 'timing',
          type: 'string'
        },
        writtenBy: {
          name: 'Written By',
          key: 'writtenBy',
          type: 'model',
          modelClass: UserReference,
          defaultValue: new UserReference()
        },
        account: {
          name: 'Account',
          key: 'account',
          type: 'model',
          modelClass: AccountWithPath,
          defaultValue: new AccountWithPath()
        },
        accounts: {
          name: 'Accounts',
          key: 'accounts',
          type: 'modelCollection',
          modelClass: AccountWithPath
        },
        documentNumber: {
          name: 'Document Number',
          key: 'documentNumber',
          type: 'string'
        },
        replaces: {
          name: 'Replaces',
          key: 'replaces',
          type: 'model',
          modelClass: RecommendationReference
        },
        cropNames: {
          name: 'Crop Names',
          key: 'cropNames',
          type: 'array'
        },
        organic: {
          name: 'Organic',
          key: 'organic',
          type: 'boolean'
        },
        notes: {
          name: 'Notes',
          key: 'notes',
          type: 'string'
        },
        targetRate: {
          name: 'Target GPA',
          key: 'targetRate',
          type: 'model',
          modelClass: Quantity,
          defaultValue: new Quantity('')
        },
        targetGallonsPerAcre: {
          name: 'Target GPA',
          key: 'targetGallonsPerAcre',
          type: 'model',
          modelClass: Quantity,
          defaultValue: new Quantity('')
        },
        productApplications: {
          name: 'Product Application',
          key: 'productApplications',
          type: 'modelCollection',
          modelClass: RecommendationProductApplication
        },
        fields: {
          name: 'Field',
          key: 'fields',
          type: 'modelCollection',
          modelClass: Field
        },
        status: {
          name: 'Status',
          key: 'status',
          type: 'string',
          defaultValue: 'draft' // draft | complete | void | replaced | pending-approval
        },

        tankSize: {
          name: 'Tank Size',
          key: 'tankSize',
          type: 'model',
          modelClass: Quantity,
          defaultValue: new Quantity('')
        },
        optimumTemperature: {
          name: 'Optimum Temperature',
          key: 'optimumTemperature',
          type: 'string',
          defaultValue: '40º - 80ºF'
        },
        areasToTreat: {
          name: 'Areas To Treat',
          key: 'areasToTreat',
          type: 'string',
          defaultValue: 'Specific Fields'
        },
        rejected: {
          name: 'Rejected',
          key: 'rejected',
          type: 'model',
          modelClass: Reject
        },
        coverage: {
          name: 'Coverage',
          key: 'coverage',
          type: 'number',
          defaultValue: 1
        },
        showProductTotals: {
          name: 'Show Product Totals',
          key: 'showProductTotals',
          type: 'boolean',
          defaultValue: true
        }
      });
    }
  }, {
    key: "isRecommendation",
    value: function isRecommendation(maybeRecommendation) {
      return maybeRecommendation instanceof Recommendation;
    }
  }, {
    key: "groupRecommendationsByAccount",
    value: function groupRecommendationsByAccount(recommendations) {
      return groupBy(function (recommendation) {
        var _recommendation$accou;
        return (_recommendation$accou = recommendation.account) === null || _recommendation$accou === void 0 ? void 0 : _recommendation$accou.name;
      })(recommendations);
    }
  }]);
  return Recommendation;
}(MixInto(UpdatableBase, idAttributeMixin, nameAttributeMixin, typeAttributeMixin, timestampAttributesMixin, applicationMethodAttributeMixin, checkableMixin, validatableMixin)), _defineProperty(_class2$3, "type", 'IF2::Recommendation'), _defineProperty(_class2$3, "findAppOptionByText", function (applicationMethodOption) {
  return _class2$3.applicationMethods.find(function (a) {
    return a.text === applicationMethodOption;
  });
}), _defineProperty(_class2$3, "areasToTreatOptions", ['Specific Fields']), _defineProperty(_class2$3, "timingOptions", ['Today', 'Next 7 Days', 'Next 14 Days']), _defineProperty(_class2$3, "optimumTemperatureOptions", ['35º - 85ºF', '40º - 80ºF']), _defineProperty(_class2$3, "targetRateOptions", ['25', '50', '80', '100', '200', '400']), _defineProperty(_class2$3, "tankSizeOptions", ['100', '150', '200', '300', '400', '500']), _defineProperty(_class2$3, "draftFilter", function (accessor) {
  return compose(anyPass([equals('draft'), isNil, isEmpty]), accessor('status'));
}), _defineProperty(_class2$3, "rejectedFilter", function (accessor) {
  return compose(anyPass([is(Object), is(String)]), accessor('rejected'));
}), _defineProperty(_class2$3, "statusFilter", curry(function (status, accessor) {
  return compose(equals(status), accessor('status'));
})), _defineProperty(_class2$3, "voidFilter", function (accessor) {
  return compose(anyPass([equals('void'), equals('replaced')]), accessor('status'));
}), _temp$3), (_descriptor = _applyDecoratedDescriptor(_class$3.prototype, "void", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class$3.prototype, "associatedAccountIds", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "associatedAccountIds"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "totalAcres", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "totalAcres"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "title", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "title"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "dateTitle", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "dateTitle"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "updatedAtTitle", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "updatedAtTitle"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "fieldAccounts", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "fieldAccounts"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "maxPhi", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "maxPhi"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "maxRei", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "maxRei"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "isComplete", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "isComplete"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "isDraft", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "isDraft"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "isProvisional", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "isProvisional"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "isVoid", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "isVoid"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "isReplaced", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "isReplaced"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "isRejected", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "isRejected"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "isPendingApproval", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "isPendingApproval"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "defaultFilename", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "defaultFilename"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "defaultFilenameBase", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "defaultFilenameBase"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "defaultFilenamePendingApproval", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "defaultFilenamePendingApproval"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "hasProductNotes", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "hasProductNotes"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "productNotes", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "productNotes"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "productApplicationCalculations", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "productApplicationCalculations"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "currentCropNamesFromFields", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "currentCropNamesFromFields"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "coveragePercentString", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "coveragePercentString"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "hasErrors", [computed], Object.getOwnPropertyDescriptor(_class$3.prototype, "hasErrors"), _class$3.prototype), _descriptor2 = _applyDecoratedDescriptor(_class$3.prototype, "pushProductApplication", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;
    return function (pa) {
      var existingInstance = _this3.productApplications.find(function (element) {
        return element.id === pa.id;
      });
      if (existingInstance) {
        existingInstance.update(pa.toJS());
        return;
      }
      _this3.productApplications.push(pa);
    };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class$3.prototype, "removeProductApplication", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;
    return function (pa) {
      var idx = _this4.productApplications.findIndex(function (element) {
        return element.id === pa.id;
      });
      if (idx < 0) {
        return;
      }
      _this4.productApplications.splice(idx, 1);
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class$3.prototype, "moveProductApplication", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this5 = this;
    return function (p, toIndex) {
      var fromIndex = _this5.productApplications.findIndex(function (pa) {
        return pa.id === p.id;
      });
      if (fromIndex < 0 || toIndex < 0 || fromIndex === toIndex) {
        return;
      }
      var _this5$productApplica = _this5.productApplications.splice(fromIndex, 1),
        _this5$productApplica2 = _slicedToArray(_this5$productApplica, 1),
        paToMove = _this5$productApplica2[0];
      if (!paToMove) {
        return;
      }
      _this5.productApplications.splice(toIndex, 0, paToMove);
      var modified = [];
      _this5.productApplications.forEach(function (pa, position) {
        if (pa.position !== position) {
          pa.update({
            position: position
          });
          modified.push(pa);
        }
      });
      return modified;
    };
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class$3.prototype, "addField", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this6 = this;
    return function (f) {
      return _this6.fields.push(f);
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class$3.prototype, "removeField", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this7 = this;
    return function (f) {
      var idx = _this7.fields.findIndex(function (element) {
        return element.id === f.id;
      });
      if (idx < 0) {
        return;
      }
      _this7.fields.splice(idx, 1);
    };
  }
})), _class$3);
var _class$2, _class2$2, _temp$2;
var SprayRecordApplicator = (_class$2 = (_temp$2 = _class2$2 = /*#__PURE__*/function (_MixInto) {
  _inherits(SprayRecordApplicator, _MixInto);
  var _super = _createSuper(SprayRecordApplicator);
  function SprayRecordApplicator() {
    _classCallCheck(this, SprayRecordApplicator);
    return _super.apply(this, arguments);
  }
  _createClass(SprayRecordApplicator, [{
    key: "name",
    get: function get() {
      var _this$contact;
      return ((_this$contact = this.contact) === null || _this$contact === void 0 ? void 0 : _this$contact.name) || '';
    }
  }, {
    key: "phone",
    get: function get() {
      var _this$contact2;
      return ((_this$contact2 = this.contact) === null || _this$contact2 === void 0 ? void 0 : _this$contact2.phone) || '';
    }
  }, {
    key: "address",
    get: function get() {
      var _this$contact3;
      return ((_this$contact3 = this.contact) === null || _this$contact3 === void 0 ? void 0 : _this$contact3.address) || '';
    }
  }, {
    key: "email",
    get: function get() {
      var _this$contact4;
      return ((_this$contact4 = this.contact) === null || _this$contact4 === void 0 ? void 0 : _this$contact4.email) || '';
    }
  }, {
    key: "licenseNumber",
    get: function get() {
      var _this$contact5;
      return ((_this$contact5 = this.contact) === null || _this$contact5 === void 0 ? void 0 : _this$contact5.licenseNumber) || '';
    }
  }], [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(SprayRecordApplicator), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: this.type
        }),
        applicationId: {
          name: 'Application ID',
          key: 'applicationId',
          type: 'number'
        },
        contact: {
          name: 'Contact',
          key: 'contact',
          type: 'model',
          modelClass: Contact,
          defaultValue: new Contact()
        },
        tractor: {
          name: 'Tractor',
          key: 'tractor',
          type: 'model',
          modelClass: Tractor,
          defaultValue: new Tractor()
        },
        sprayer: {
          name: 'Sprayer',
          key: 'sprayer',
          type: 'model',
          modelClass: Sprayer,
          defaultValue: new Sprayer()
        },
        sprayRate: {
          name: 'Spray Rate',
          key: 'sprayRate',
          type: 'model',
          modelClass: Quantity
        },
        tanksCompleted: {
          name: 'Tanks Completed',
          key: 'tanksCompleted',
          type: 'number'
        }
      });
    }
  }]);
  return SprayRecordApplicator;
}(MixInto(UpdatableBase, idAttributeMixin, serialAttributeMixin, typeAttributeMixin)), _defineProperty(_class2$2, "type", 'IF2::SprayRecord::Applicator'), _temp$2), (_applyDecoratedDescriptor(_class$2.prototype, "name", [computed], Object.getOwnPropertyDescriptor(_class$2.prototype, "name"), _class$2.prototype), _applyDecoratedDescriptor(_class$2.prototype, "phone", [computed], Object.getOwnPropertyDescriptor(_class$2.prototype, "phone"), _class$2.prototype), _applyDecoratedDescriptor(_class$2.prototype, "address", [computed], Object.getOwnPropertyDescriptor(_class$2.prototype, "address"), _class$2.prototype), _applyDecoratedDescriptor(_class$2.prototype, "email", [computed], Object.getOwnPropertyDescriptor(_class$2.prototype, "email"), _class$2.prototype), _applyDecoratedDescriptor(_class$2.prototype, "licenseNumber", [computed], Object.getOwnPropertyDescriptor(_class$2.prototype, "licenseNumber"), _class$2.prototype)), _class$2);
var _class$1, _class2$1, _temp$1;
var SprayRecordApplication = (_class$1 = (_temp$1 = _class2$1 = /*#__PURE__*/function (_MixInto) {
  _inherits(SprayRecordApplication, _MixInto);
  var _super = _createSuper(SprayRecordApplication);
  function SprayRecordApplication() {
    _classCallCheck(this, SprayRecordApplication);
    return _super.apply(this, arguments);
  }
  _createClass(SprayRecordApplication, [{
    key: "isOvernight",
    get: function get() {
      var start = this.constructor.parseTime(this.startTime);
      var stop = this.constructor.parseTime(this.stopTime);
      return start && start > stop;
    }
  }, {
    key: "windDirectionAndSpeed",
    get: function get() {
      var low = Quantity.displayValue(this.lowWindSpeed);
      var high = Quantity.displayValue(this.highWindSpeed);
      var speed;
      if (low && high && low !== high) {
        speed = "".concat(this.lowWindSpeed.scalar, "-").concat(this.highWindSpeed.scalar, " ").concat(this.highWindSpeed.units);
      } else if (low) {
        speed = low;
      } else if (high) {
        speed = high;
      }
      if (!speed) return '';
      if (!this.windDirection || speed === '0 mph') return speed;
      return "".concat(this.windDirection, " ").concat(speed);
    }
  }], [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(SprayRecordApplication), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        date: {
          name: 'Date',
          key: 'date',
          type: 'string'
        },
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: this.type
        }),
        sprayRecordId: {
          name: 'Spray Record ID',
          key: 'sprayRecordId',
          type: 'number'
        },
        startTime: {
          name: 'Start Time',
          key: 'startTime',
          type: 'string'
        },
        stopTime: {
          name: 'Stop Time',
          key: 'stopTime',
          type: 'string'
        },
        windDirection: {
          name: 'Wind Direction',
          key: 'windDirection',
          type: 'string'
        },
        temperatureUnits: {
          name: 'Temperature Units',
          key: 'temperatureUnits',
          type: 'string',
          defaultValue: 'F'
        },
        temperatureLow: {
          name: 'Temperature Low',
          key: 'temperatureLow',
          type: 'string'
        },
        temperatureHigh: {
          name: 'Temperature High',
          key: 'temperatureHigh',
          type: 'string'
        },
        lowWindSpeed: {
          name: 'Low Wind Speed',
          key: 'lowWindSpeed',
          type: 'model',
          modelClass: Quantity
        },
        highWindSpeed: {
          name: 'High Wind Speed',
          key: 'highWindSpeed',
          type: 'model',
          modelClass: Quantity
        },
        applicators: {
          name: 'Applicator',
          key: 'applicators',
          type: 'modelCollection',
          modelClass: SprayRecordApplicator
        },
        fieldCompletions: {
          name: 'Field Completion',
          key: 'fieldCompletions',
          type: 'modelCollection',
          modelClass: FieldCompletion
        }
      });
    }
  }, {
    key: "from",
    value: function from(props) {
      return new this(props);
    }
  }, {
    key: "parseTime",
    value: function parseTime(time) {
      return moment(time, ['h:mm a', 'H:mm', 'k:mm']).format('HH:mm');
    }
  }]);
  return SprayRecordApplication;
}(MixInto(UpdatableBase, idAttributeMixin, serialAttributeMixin, typeAttributeMixin)), _defineProperty(_class2$1, "type", 'IF2::SprayRecord::Application'), _temp$1), (_applyDecoratedDescriptor(_class$1.prototype, "isOvernight", [computed], Object.getOwnPropertyDescriptor(_class$1.prototype, "isOvernight"), _class$1.prototype), _applyDecoratedDescriptor(_class$1.prototype, "windDirectionAndSpeed", [computed], Object.getOwnPropertyDescriptor(_class$1.prototype, "windDirectionAndSpeed"), _class$1.prototype)), _class$1);
var SprayRecordProductApplication = /*#__PURE__*/function (_ProductApplicationBa) {
  _inherits(SprayRecordProductApplication, _ProductApplicationBa);
  var _super = _createSuper(SprayRecordProductApplication);
  function SprayRecordProductApplication() {
    _classCallCheck(this, SprayRecordProductApplication);
    return _super.apply(this, arguments);
  }
  _createClass(SprayRecordProductApplication, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(SprayRecordProductApplication), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: this.type
        }),
        sprayRecordId: {
          name: 'Spray Record ID',
          key: 'sprayRecordId',
          type: 'number'
        },
        phi: {
          name: 'PHI',
          key: 'phi',
          type: 'model',
          modelClass: Quantity
        },
        rei: {
          name: 'REI',
          key: 'rei',
          type: 'model',
          modelClass: Quantity
        },
        phiOverride: {
          name: 'PHI Override',
          key: 'phiOverride',
          type: 'model',
          modelClass: Quantity
        },
        phiOverrideBy: {
          name: 'PHI Overridden By',
          key: 'phiOverrideBy',
          type: 'string'
        },
        phiOverrideReason: {
          name: 'PHI Override Reason',
          key: 'phiOverrideReason',
          type: 'string'
        },
        reiOverride: {
          name: 'REI Override',
          key: 'reiOverride',
          type: 'model',
          modelClass: Quantity
        },
        reiOverrideBy: {
          name: 'REI Overridden By',
          key: 'reiOverrideBy',
          type: 'string'
        },
        reiOverrideReason: {
          name: 'REI Override Reason',
          key: 'reiOverrideReason',
          type: 'string'
        },
        total: {
          name: 'Total',
          key: 'total',
          type: 'model',
          modelClass: Quantity
        }
      });
    }
  }]);
  return SprayRecordProductApplication;
}(ProductApplicationBase);
_defineProperty(SprayRecordProductApplication, "type", 'IF2::SprayRecord::ProductApplication');
var SprayRecordRecommendationReference = /*#__PURE__*/function (_MixInto) {
  _inherits(SprayRecordRecommendationReference, _MixInto);
  var _super = _createSuper(SprayRecordRecommendationReference);
  function SprayRecordRecommendationReference() {
    _classCallCheck(this, SprayRecordRecommendationReference);
    return _super.apply(this, arguments);
  }
  _createClass(SprayRecordRecommendationReference, null, [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      return _objectSpread2(_objectSpread2({}, _get(_getPrototypeOf(SprayRecordRecommendationReference), "getAttributeDefinition", this).call(this)), {}, {
        documentNumber: {
          name: 'Document Number',
          key: 'documentNumber',
          type: 'string'
        },
        date: {
          name: 'Date',
          key: 'date',
          type: 'string'
        },
        writtenBy: {
          name: 'Written By',
          key: 'writtenBy',
          type: 'model',
          modelClass: UserReference,
          defaultValue: new UserReference()
        }
      });
    }
  }]);
  return SprayRecordRecommendationReference;
}(MixInto(UpdatableBase, idAttributeMixin, nameAttributeMixin));
var _class, _class2, _temp;
var SprayRecord = (_class = (_temp = _class2 = /*#__PURE__*/function (_MixInto) {
  _inherits(SprayRecord, _MixInto);
  var _super = _createSuper(SprayRecord);
  function SprayRecord() {
    var _this;
    _classCallCheck(this, SprayRecord);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "parseTime", function (time) {
      return moment(time, ['h:mm a', 'H:mm', 'k:mm']).format('HH:mm');
    });
    return _this;
  }
  _createClass(SprayRecord, [{
    key: "abbreviatedDateTitle",
    get: function get() {
      var thisYear = moment().format('YYYY');
      if (this.dates.length <= 0) {
        if (!this.dateTitle) {
          return '';
        }
        var dateTitle = moment(this.dateTitle, 'M/D/YYYY');
        return dateTitle.format('YYYY') === thisYear ? dateTitle.format('M/D') : dateTitle.format('M/D/YYYY');
      }
      var first = this.dates[0];
      var firstYear = first.format('YYYY');
      var firstFormatted = firstYear === thisYear ? first.format('M/D') : first.format('M/D/YYYY');
      var last = this.dates[this.dates.length - 1];
      var lastFormatted = last.format('YYYY') === thisYear ? last.format('M/D') : last.format('M/D/YYYY');
      return this.dates.length === 1 || firstFormatted === lastFormatted ? firstFormatted : firstYear === last.format('YYYY') ? "".concat(first.format('M/D'), " - ").concat(last.format('M/D')).concat(firstYear !== thisYear ? ", ".concat(firstYear) : '') : "".concat(first.format('M/D/YYYY'), " - ").concat(last.format('M/D/YYYY'));
    }
  }, {
    key: "dates",
    get: function get() {
      return this.sortedApplications.filter(function (app) {
        return app.date;
      }).map(function (app) {
        return moment(app.date);
      });
    }
  }, {
    key: "dateTitle",
    get: function get() {
      if (this.dates.length <= 0) return this.recommendation && this.recommendation.date && moment(this.recommendation.date).format('M/D/YYYY') || '';
      var first = this.dates[0];
      var firstFormatted = first.format('M/D/YYYY');
      var last = this.dates[this.dates.length - 1];
      var lastFormatted = last.format('M/D/YYYY');
      return this.dates.length === 1 || firstFormatted === lastFormatted ? firstFormatted : "".concat(firstFormatted, " - ").concat(lastFormatted);
    }
  }, {
    key: "fieldCompletionPercents",
    get: function get() {
      var percents = {};
      this.fields.forEach(function (field) {
        percents[field.id] = 0;
      });
      this.applications.forEach(function (application) {
        application.fieldCompletions.forEach(function (completion) {
          percents[completion.field.id] += Number(completion.percentage);
        });
      });
      return percents;
    }
  }, {
    key: "sortedApplications",
    get: function get() {
      var _this2 = this;
      var applications = this.applications || [];
      return applications.slice().sort(function (a, b) {
        var sortedByDate = naturalSort(moment(a.date).format('YYYYMMDD'), moment(b.date).format('YYYYMMDD'));
        if (sortedByDate === 0) {
          return _this2.sortByStartTime(a, b);
        }
        return sortedByDate;
      });
    }
  }, {
    key: "title",
    get: function get() {
      return this.name || this.abbreviatedDateTitle || (this.applicationMethod ? "".concat(this.applicationMethod, " Application") : '');
    }
  }, {
    key: "updatedAtDate",
    get: function get() {
      return moment(this.updatedAt, ['M/D/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') || '';
    }
  }, {
    key: "updatedAtTitle",
    get: function get() {
      return moment(this.updatedAt, ['M/D/YYYY', 'YYYY-MM-DD']).format('M/D/YYYY') || '';
    }
  }, {
    key: "sortByStartTime",
    value: function sortByStartTime(a, b) {
      var sortedByStartTime = naturalSort(this.parseTime(a.startTime), this.parseTime(b.startTime));
      if (sortedByStartTime === 0) {
        return naturalSort(this.parseTime(a.stopTime), this.parseTime(b.stopTime));
      }
      return sortedByStartTime;
    }
  }, {
    key: "findApplication",
    value: function findApplication(id) {
      return this.applications.find(function (a) {
        return a.serial === id;
      });
    }
  }, {
    key: "findProductApplication",
    value: function findProductApplication(id) {
      return this.productApplications.find(function (pa) {
        return pa.serial === id;
      });
    }
  }, {
    key: "moveProductApplication",
    value: function moveProductApplication(id, from, to) {
      var productApplication = this.findProductApplication(id);
      if (!productApplication) {
        return;
      }
      var fromIndex = this.productApplications.findIndex(function (pa) {
        return pa.position === from;
      });
      var toIndex = this.productApplications.findIndex(function (pa) {
        return pa.position === to;
      });
      this.productApplications.splice(fromIndex, 1);
      this.productApplications.splice(toIndex, 0, productApplication);
      this.updateProductApplicationPositions();
    }
  }, {
    key: "removeApplication",
    value: function removeApplication(id) {
      var index = this.applications.findIndex(function (app) {
        return app.serial === id;
      });
      if (index < 0) {
        return;
      }
      this.applications.splice(index, 1);
    }
  }, {
    key: "removeProductApplication",
    value: function removeProductApplication(id) {
      var paIndex = this.productApplications.findIndex(function (pa) {
        return pa.serial === id;
      });
      if (paIndex < 0) {
        return;
      }
      this.productApplications.splice(paIndex, 1);
      this.updateProductApplicationPositions();
    }
  }, {
    key: "pushApplication",
    value: function pushApplication(application) {
      return push(this.applications, SprayRecordApplication.from.bind(SprayRecordApplication), application, {
        searchKey: 'serial'
      });
    }
  }, {
    key: "updateProductApplicationPositions",
    value: function updateProductApplicationPositions() {
      this.productApplications.forEach(function (pa, i) {
        if (pa.position === i) return;
        pa.update({
          position: i
        });
      });
    }
  }, {
    key: "updateProductApplication",
    value: function updateProductApplication(productApplication) {
      push(this.productApplications, SprayRecordProductApplication.from.bind(SprayRecordProductApplication), productApplication, {
        searchKey: 'serial'
      });
      this.updateProductApplicationPositions();
      return this.productApplications;
    }
  }], [{
    key: "getAttributeDefinition",
    value: function getAttributeDefinition() {
      var inherited = _get(_getPrototypeOf(SprayRecord), "getAttributeDefinition", this).call(this);
      return _objectSpread2(_objectSpread2({}, inherited), {}, {
        type: _objectSpread2(_objectSpread2({}, inherited.type), {}, {
          defaultValue: this.type
        }),
        account: {
          name: 'Account',
          key: 'account',
          type: 'model',
          modelClass: AccountWithPath
        },
        cropNames: {
          name: 'Crop Names',
          key: 'cropNames',
          type: 'array'
        },
        organic: {
          name: 'Organic',
          key: 'organic',
          type: 'boolean'
        },
        notes: {
          name: 'Notes',
          key: 'notes',
          type: 'string'
        },
        targetGallonsPerAcre: {
          name: 'Target GPA',
          key: 'targetGallonsPerAcre',
          type: 'number'
        },
        licensedApplicator: {
          name: 'Licensed Applicator',
          key: 'licensedApplicator',
          type: 'model',
          modelClass: Contact
        },
        fields: {
          name: 'Field',
          key: 'fields',
          type: 'modelCollection',
          modelClass: Field
        },
        recommendation: {
          name: 'Recommendation',
          key: 'recommendation',
          type: 'model',
          modelClass: SprayRecordRecommendationReference
        },
        complete: {
          name: 'Complete',
          key: 'complete',
          type: 'boolean'
        },
        showFieldMap: {
          name: 'Show Field Map',
          key: 'showFieldMap',
          type: 'boolean'
        },
        applications: {
          name: 'Application',
          key: 'applications',
          type: 'modelCollection',
          modelClass: SprayRecordApplication
        },
        maxPhi: {
          name: 'Max PHI',
          key: 'maxPhi',
          type: 'model',
          modelClass: Quantity
        },
        maxRei: {
          name: 'Max REI',
          key: 'maxRei',
          type: 'model',
          modelClass: Quantity
        },
        productApplications: {
          name: 'Product Application',
          key: 'productApplications',
          type: 'modelCollection',
          modelClass: SprayRecordProductApplication
        },
        targetCoveragePercentage: {
          name: 'Coverage',
          key: 'targetCoveragePercentage',
          type: 'number'
        }
      });
    }
  }, {
    key: "isSprayRecord",
    value: function isSprayRecord(maybeSprayRecord) {
      return maybeSprayRecord instanceof SprayRecord;
    }
  }]);
  return SprayRecord;
}(MixInto(UpdatableBase, idAttributeMixin, serialAttributeMixin, nameAttributeMixin, typeAttributeMixin, timestampAttributesMixin, applicationMethodAttributeMixin, checkableMixin)), _defineProperty(_class2, "type", 'IF2::SprayRecord'), _temp), (_applyDecoratedDescriptor(_class.prototype, "abbreviatedDateTitle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "abbreviatedDateTitle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dates", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dates"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dateTitle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dateTitle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fieldCompletionPercents", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "fieldCompletionPercents"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sortedApplications", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "sortedApplications"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "title", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "title"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updatedAtDate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "updatedAtDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updatedAtTitle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "updatedAtTitle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "moveProductApplication", [action], Object.getOwnPropertyDescriptor(_class.prototype, "moveProductApplication"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeApplication", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeApplication"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeProductApplication", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeProductApplication"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pushApplication", [action], Object.getOwnPropertyDescriptor(_class.prototype, "pushApplication"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateProductApplicationPositions", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateProductApplicationPositions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateProductApplication", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateProductApplication"), _class.prototype)), _class);
export { AbstractValidation, AccountReference, AccountWithPath, ActiveIngredient, Contact, ContactAddress, ContactEmail, ContactInfoItem, ContactPhone, Failure, Feature, FeatureBuilder, FeatureCollection, FeatureGeometry, FeatureGeometryBase, Field, FieldCompletion, FieldCropCultivar, FieldCropReference, FieldCropRootStock, FieldCropVariety, FieldReference, Formulation, GeoJSON, GeoJSONBase, GeoJsonError, IF2JsModelError, InvalidFeatureError, InvalidGeoJsonError, Mix, MixInto, ModeOfAction, ModelReference, MultiPolygonGeometry, NutrientAnalysis, OrganicListing, OrganicProductValidation, PointGeometry, PolygonGeometry, Presence, Product, ProductApplicationBase, ProductApplicationCalculation, ProductCropLabel, ProductLabelValidation, ProductRecommendationNote, ProductReference, Quantity, QuantityComparison, Recommendation, RecommendationProductApplication, RecommendationReference, Reject, Spec, SprayRecord, SprayRecordApplication, SprayRecordApplicator, SprayRecordProductApplication, SprayRecordRecommendationReference, Sprayer, Tractor, UnsupportedGeometryTypeError, UpdatableBase, UserReference, bulletListString, checkableCollectionMixin, checkableMixin, decimalToPercentString, editableMixin, expandableCollectionMixin, find, findMany, genericSort, humanize, idAttributeMixin, includesAll, includesAny, isString, listString, loadingStatusCollectionMixin, loggableMixin, nameAttributeMixin, naturalSort, percentStringToDecimal, push, remove, reportableMixin, selectableMixin, serialAttributeMixin, sortByName, timestampAttributesMixin, toJS, truncateZeros, typeAttributeMixin, uniq, uniqBy, updatableMixin, validatableMixin };